import PropertyApplicationDrafts from "./PropertyApplicationDrafts";
import PropertyApplications from "./PropertyApplications";
import CrmImportDiagnostics from "./CrmImportDiagnostics";
import { getPersonData } from "../../utils/myinfoData";
import React, {
  useCallback,
  useEffect,
  useMemo,
  useRef,
  useState,
} from "react";
import Cookies from "js-cookie";
import { useHistory } from "react-router-dom";
import ProfileViewer from "../borrower-dashboard/ProfileViewer";
import LoanRequestGrid from "../../scenes/loan-request-grid";
import pdfToText from "react-pdftotext";
import { message, Modal } from "antd";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import {
  faBuilding,
  faHome,
  faMobileAlt,
  faPhone,
  faStar,
  faTabletAlt,
  faUser,
} from "@fortawesome/free-solid-svg-icons";
import { faWhatsapp } from "@fortawesome/free-brands-svg-icons";

const SupportDashboard = () => {
  const history = useHistory();
  const [borrowers, setBorrowers] = useState([]);
  const [crmImports, setCrmImports] = useState({});
  const crmImportsInFlight = useRef(new Set());
  const [selectedBorrower, setSelectedBorrower] = useState(null);
  const [selectedBorrowerProfile, setSelectedBorrowerProfile] = useState(null);
  const [remarkBorrower, setRemarkBorrower] = useState(null);
  const [isLoading, setIsLoading] = useState(true);
  const [isRefreshing, setIsRefreshing] = useState(false);
  const [error, setError] = useState("");
  const [isProfileLoading, setIsProfileLoading] = useState(false);
  const [remarks, setRemarks] = useState([]);
  const [newRemark, setNewRemark] = useState("");
  const [isSavingRemark, setIsSavingRemark] = useState(false);
  const [viewingUser, setViewingUser] = useState(null);
  const [singpassData, setSingpassData] = useState(null);
  const [myinfoData, setMyinfoData] = useState(null);
  const [combinedSingpassData, setCombinedSingpassData] = useState([]);
  const [liveUserData, setLiveUserData] = useState(null);
  const [otherAuthoriserDetails] = useState([]);
  const [viewingTab, setViewingTab] = useState(0);
  const [badgeVerified, setBadgeVerified] = useState(false);
  const [allCBSData, setAllCBSData] = useState([]);
  const [backupContact, setBackupContact] = useState("");
  const [keyman, setKeyman] = useState("");
  const [searchTerm, setSearchTerm] = useState("");
  const [assignmentFilter, setAssignmentFilter] = useState("all");
  const [cbsFilter, setCbsFilter] = useState("all");
  const [cbsIntentFilter, setCbsIntentFilter] = useState("all");
  const [companyFilter, setCompanyFilter] = useState("all");
  const [phoneFilter, setPhoneFilter] = useState("all");
  const [statusFilter, setStatusFilter] = useState("all");
  const [employeeFilter, setEmployeeFilter] = useState("");
  const [dateRange, setDateRange] = useState({ start: "", end: "" });
  const [propertyCampaignLeads, setPropertyCampaignLeads] = useState([]);
  const [propertyCampaignLeadSearch, setPropertyCampaignLeadSearch] =
    useState("");
  const [isPropertyCampaignLeadsLoading, setIsPropertyCampaignLeadsLoading] =
    useState(false);
  const [propertyCampaignLeadError, setPropertyCampaignLeadError] =
    useState("");
  const [creditReportFile, setCreditReportFile] = useState(null);
  const [creditFile, setCreditFile] = useState(null);
  const [isUploadingCbs, setIsUploadingCbs] = useState(false);
  const [showCbsUploader, setShowCbsUploader] = useState(false);
  const [assignees, setAssignees] = useState([]);
  const [isAssigneeModalOpen, setIsAssigneeModalOpen] = useState(false);
  const [assigneeStep, setAssigneeStep] = useState(1);
  const [assigneeTarget, setAssigneeTarget] = useState(null);
  const [selectedAssigneeId, setSelectedAssigneeId] = useState("");
  const [assigneeRemark, setAssigneeRemark] = useState("");
  const [isAssigningBorrower, setIsAssigningBorrower] = useState(false);
  const [caseBorrower, setCaseBorrower] = useState(null);
  const [selectedCaseProduct, setSelectedCaseProduct] =
    useState("money_lender");
  const [borrowerCases, setBorrowerCases] = useState([]);
  const [selectedCase, setSelectedCase] = useState(null);
  const [caseTimeline, setCaseTimeline] = useState([]);
  const [isCreatingCase, setIsCreatingCase] = useState(false);
  const [newCaseRemark, setNewCaseRemark] = useState("");
  const [isSavingCaseRemark, setIsSavingCaseRemark] = useState(false);
  const [caseDocumentFile, setCaseDocumentFile] = useState(null);
  const [caseDocumentRemark, setCaseDocumentRemark] = useState("");
  const [isUploadingCaseDocument, setIsUploadingCaseDocument] = useState(false);
  const supportEmployeeName = Cookies.get("support_employee_name") || "";
  const isLoanRequestOnlySupportUser =
    supportEmployeeName.trim().toLowerCase() === "tllogin";
  const [activeView, setActiveView] = useState(
    isLoanRequestOnlySupportUser ? "loan-requests" : "dashboard",
  );
  const [caseBoardStatuses, setCaseBoardStatuses] = useState([]);
  const [isCaseBoardLoading, setIsCaseBoardLoading] = useState(false);
  const [expandedStatuses, setExpandedStatuses] = useState({});
  const [expandedCases, setExpandedCases] = useState({});
  const [deletingCaseId, setDeletingCaseId] = useState(null);
  const [caseViewRemarkDrafts, setCaseViewRemarkDrafts] = useState({});
  const [caseViewSavingRemarkCaseId, setCaseViewSavingRemarkCaseId] =
    useState(null);
  const [caseViewDocumentFiles, setCaseViewDocumentFiles] = useState({});
  const [caseViewDocumentRemarks, setCaseViewDocumentRemarks] = useState({});
  const [caseViewUploadingDocCaseId, setCaseViewUploadingDocCaseId] =
    useState(null);
  const [caseViewUpdatingStatusCaseId, setCaseViewUpdatingStatusCaseId] =
    useState(null);
  const [tagLoanModal, setTagLoanModal] = useState({
    open: false,
    caseId: null,
    borrowerId: null,
  });
  const [availableLoans, setAvailableLoans] = useState([]);
  const [isLoadingAvailableLoans, setIsLoadingAvailableLoans] = useState(false);
  const [taggingLoanCaseId, setTaggingLoanCaseId] = useState(null);
  const [borrowerPage, setBorrowerPage] = useState(1);
  const [borrowersPerPage, setBorrowersPerPage] = useState(100);
  const [totalBorrowers, setTotalBorrowers] = useState(0);
  const [totalBorrowerPages, setTotalBorrowerPages] = useState(1);
  const [isDownloadingBorrowerEmails, setIsDownloadingBorrowerEmails] =
    useState(false);
  const createLoanInitialForm = useCallback(
    () => ({
      loan_type: "money_lender",
      case_type: "normal",
      amount: "",
      tenor_months: "",
      desired_rate_pa: "3.92",
      corporate_interest_rate: "1",
      contact_email: "",
      contact_phone: "",
      notes: "",
      cbs_report: null,
      mlcb_report: null,
      payslips: [],
      bank_statements: [],
    }),
    [],
  );
  const [createLoanBorrower, setCreateLoanBorrower] = useState(null);
  const [createLoanForm, setCreateLoanForm] = useState(createLoanInitialForm);
  const [isCreatingLoan, setIsCreatingLoan] = useState(false);
  const [clientAccountForm, setClientAccountForm] = useState({
    client_name: "",
    email: "",
    mobile_no: "",
  });
  const [isCreatingClientAccount, setIsCreatingClientAccount] = useState(false);
  const [createdClientAccount, setCreatedClientAccount] = useState(null);
  const [isClientAccountModalOpen, setIsClientAccountModalOpen] =
    useState(false);

  const formatCurrency = useCallback((value) => {
    if (value === null || value === undefined || value === "") {
      return "-";
    }
    const numeric = Number(value);
    if (Number.isNaN(numeric)) {
      return value;
    }
    return numeric.toLocaleString("en-SG", {
      style: "currency",
      currency: "SGD",
      maximumFractionDigits: 2,
    });
  }, []);

  const productIconMap = useMemo(
    () => ({
      "b-personal-loans": { icon: faUser, label: "Personal loan" },
      "b-loan-hub": { icon: faBuilding, label: "Corporate loan" },
      "b-instant-prop-term-loan": { icon: faHome, label: "Property term loan" },
    }),
    [],
  );

  const deviceIconMap = useMemo(
    () => ({
      mobile: { icon: faMobileAlt, label: "Mobile" },
      desktop_tablet: { icon: faTabletAlt, label: "Tablet/Laptop" },
    }),
    [],
  );
  const normalizePhoneNumber = useCallback((phoneNumber) => {
    // 1. Handle null, undefined, or empty values
    if (!phoneNumber) {
      return "";
    }

    // 2. Explicitly convert to String and then replace
    // This handles cases where phoneNumber might be a number
    return String(phoneNumber).replace(/\D/g, "");
  }, []);

  const parseMaybeJson = useCallback((value) => {
    if (!value) return null;
    if (typeof value === "object") return value;
    if (typeof value !== "string") return null;

    try {
      return JSON.parse(value);
    } catch (error) {
      return null;
    }
  }, []);

  const normalizeSearchText = useCallback((value) => {
    if (value === undefined || value === null) return "";
    return String(value).toLowerCase().replace(/\s+/g, " ").trim();
  }, []);

  const getBorrowerSearchValues = useCallback(
    (borrower) => {
      const singpassPayload = parseMaybeJson(borrower?.singpass_data);
      const myinfoPayload = parseMaybeJson(borrower?.myinfo_data);

      return [
        borrower?.borrower_display_name,
        borrower?.company_name,
        borrower?.entity_name,
        borrower?.principal_name,
        borrower?.name,
        borrower?.full_name,
        borrower?.email,
        borrower?.mobile_no,
        singpassPayload?.entity?.["basic-profile"]?.["entity-name"]?.value,
        singpassPayload?.entity?.basicProfile?.entityName?.value,
        getPersonData(singpassPayload)?.name?.value,
        myinfoPayload?.name?.value,
        getPersonData(myinfoPayload)?.name?.value,
      ].filter(Boolean);
    },
    [parseMaybeJson],
  );

  const hasSingpassPayload = useCallback(
    (borrower) =>
      Boolean(
        borrower?.has_singpass_data ?? parseMaybeJson(borrower?.singpass_data),
      ),
    [parseMaybeJson],
  );

  const hasMyInfoPayload = useCallback(
    (borrower) =>
      Boolean(
        borrower?.has_myinfo_data ?? parseMaybeJson(borrower?.myinfo_data),
      ),
    [parseMaybeJson],
  );

  const getBorrowerDisplayName = useCallback(
    (borrower) => {
      if (borrower?.borrower_display_name) {
        return borrower.borrower_display_name;
      }

      const singpassPayload = parseMaybeJson(borrower?.singpass_data);
      const myinfoPayload = parseMaybeJson(borrower?.myinfo_data);

      return (
        singpassPayload?.entity?.["basic-profile"]?.["entity-name"]?.value ||
        myinfoPayload?.name?.value ||
        getPersonData(myinfoPayload)?.name?.value ||
        borrower?.company_name ||
        borrower?.entity_name ||
        borrower?.principal_name ||
        borrower?.name ||
        "Borrower"
      );
    },
    [parseMaybeJson],
  );

  const supportStatuses = useMemo(
    () => [
      "Following Up",
      "Await Docs",
      "Full Docs Collected",
      "In Application",
      "Approved",
      "Rejected",
      "Accepted",
      "Disbursed",
      "Not Keen",
      "DNC",
      "Unreachable",
    ],
    [],
  );

  const availableTab = useMemo(
    () => [
      { name: "Personal Information" },
      { name: "Corporate Information" },
      { name: "NOA History" },
      { name: "Capitals" },
      { name: "Financials" },
      { name: "Shareholders" },
      { name: "Borrower Report" },
    ],
    [],
  );

  const supportToken = Cookies.get("support_token");
  const isAdmin = Cookies.get("support_is_admin") === "true";
  const supportSyncCookieKey = "support_sync_context";
  const [syncingBorrowerId, setSyncingBorrowerId] = useState(null);

  const clearSupportSyncContext = useCallback(() => {
    Cookies.remove(supportSyncCookieKey, { path: "/" });
    Cookies.remove(supportSyncCookieKey);
  }, []);

  useEffect(() => {
    if (isLoanRequestOnlySupportUser && activeView !== "loan-requests") {
      setActiveView("loan-requests");
    }
  }, [activeView, isLoanRequestOnlySupportUser]);

  const handleLogout = useCallback(() => {
    Cookies.remove("support_token");
    Cookies.remove("support_employee_id");
    Cookies.remove("support_employee_name");
    Cookies.remove("support_is_admin");
    clearSupportSyncContext();
    history.push("/support-login");
  }, [clearSupportSyncContext, history]);

  const downloadBorrowerEmailsCsv = useCallback(async () => {
    if (!supportToken) {
      message.error("Support session expired. Please login again.");
      history.push("/support-login");
      return;
    }

    setIsDownloadingBorrowerEmails(true);
    try {
      const response = await fetch(
        "https://www.smart-lend.com/api/support/borrowers/emails/export",
        {
          headers: {
            Authorization: `Bearer ${supportToken}`,
            Accept: "text/csv",
          },
        },
      );

      if (!response.ok) {
        let errorMessage = "Unable to download borrower emails.";
        try {
          const errorJson = await response.json();
          errorMessage = errorJson?.message || errorMessage;
        } catch (error) {
          // Keep the generic message when the response is not JSON.
        }
        throw new Error(errorMessage);
      }

      const blob = await response.blob();
      const contentDisposition = response.headers.get("content-disposition");
      const filenameMatch = contentDisposition?.match(/filename="?([^"]+)"?/i);
      const filename = filenameMatch?.[1] || "borrower-emails.csv";
      const url = window.URL.createObjectURL(blob);
      const link = document.createElement("a");
      link.href = url;
      link.download = filename;
      document.body.appendChild(link);
      link.click();
      link.remove();
      window.URL.revokeObjectURL(url);
      message.success("Borrower emails CSV downloaded.");
    } catch (err) {
      message.error(err.message || "Unable to download borrower emails.");
    } finally {
      setIsDownloadingBorrowerEmails(false);
    }
  }, [history, supportToken]);

  const fetchBorrowers = useCallback(
    async (options = {}) => {
      const {
        background = false,
        page = 1,
        perPage = 100,
        search = "",
        filters = {},
      } = options;
      const searchValue = (search || "").trim();
      const activeFilters = {
        assignmentFilter,
        cbsFilter,
        cbsIntentFilter,
        companyFilter,
        phoneFilter,
        statusFilter,
        employeeFilter,
        dateRange,
        ...filters,
      };
      if (!supportToken) {
        history.push("/support-login");
        return;
      }

      if (background) {
        setIsRefreshing(true);
      } else {
        setIsLoading(true);
      }
      setError("");
      try {
        const params = new URLSearchParams({
          page: `${page}`,
          per_page: `${perPage}`,
        });
        if (searchValue) {
          params.set("search", searchValue);
        }
        if (activeFilters.assignmentFilter !== "all") {
          params.set("assignment_filter", activeFilters.assignmentFilter);
        }
        if (activeFilters.cbsFilter !== "all") {
          params.set("cbs_filter", activeFilters.cbsFilter);
        }
        if (activeFilters.cbsIntentFilter !== "all") {
          params.set("cbs_intent_filter", activeFilters.cbsIntentFilter);
        }
        if (activeFilters.companyFilter !== "all") {
          params.set("company_filter", activeFilters.companyFilter);
        }
        if (activeFilters.phoneFilter !== "all") {
          params.set("phone_filter", activeFilters.phoneFilter);
        }
        if (activeFilters.statusFilter !== "all") {
          params.set("status_filter", activeFilters.statusFilter);
        }
        if (isAdmin && activeFilters.employeeFilter?.trim()) {
          params.set("employee_filter", activeFilters.employeeFilter.trim());
        }
        if (activeFilters.dateRange?.start) {
          params.set("registered_start", activeFilters.dateRange.start);
        }
        if (activeFilters.dateRange?.end) {
          params.set("registered_end", activeFilters.dateRange.end);
        }

        const response = await fetch(
          `https://www.smart-lend.com/api/support/borrowers?${params.toString()}`,
          {
            headers: {
              Authorization: `Bearer ${supportToken}`,
              Accept: "application/json",
            },
          },
        );

        if (!response.ok) {
          const message = await response.json();
          throw new Error(message?.message || "Unable to load borrowers");
        }

        const data = await response.json();
        const pagination = data.pagination || {};
        setBorrowers(data.borrowers || []);
        setBorrowerPage(pagination.page || page);
        setBorrowersPerPage(pagination.per_page || perPage);
        setTotalBorrowers(pagination.total || 0);
        setTotalBorrowerPages(pagination.total_pages || 1);
      } catch (err) {
        setError(err.message);
      } finally {
        if (background) {
          setIsRefreshing(false);
        } else {
          setIsLoading(false);
        }
      }
    },
    [
      assignmentFilter,
      cbsFilter,
      cbsIntentFilter,
      companyFilter,
      dateRange,
      employeeFilter,
      history,
      isAdmin,
      phoneFilter,
      statusFilter,
      supportToken,
    ],
  );

  const fetchPropertyCampaignLeads = useCallback(
    async (search = propertyCampaignLeadSearch) => {
      if (!supportToken) {
        history.push("/support-login");
        return;
      }

      setIsPropertyCampaignLeadsLoading(true);
      setPropertyCampaignLeadError("");
      try {
        const params = new URLSearchParams();
        const searchValue = (search || "").trim();
        if (searchValue) {
          params.set("search", searchValue);
        }

        const query = params.toString();
        const response = await fetch(
          `https://www.smart-lend.com/api/support/property-campaign-leads${
            query ? `?${query}` : ""
          }`,
          {
            headers: {
              Authorization: `Bearer ${supportToken}`,
              Accept: "application/json",
            },
          },
        );
        const data = await response.json().catch(() => ({}));

        if (!response.ok) {
          throw new Error(
            data?.message || "Unable to load property campaign leads.",
          );
        }

        setPropertyCampaignLeads(data?.data || []);
      } catch (err) {
        setPropertyCampaignLeadError(
          err.message || "Unable to load property campaign leads.",
        );
      } finally {
        setIsPropertyCampaignLeadsLoading(false);
      }
    },
    [history, propertyCampaignLeadSearch, supportToken],
  );

  const updateClientAccountForm = useCallback((field, value) => {
    setClientAccountForm((prev) => ({
      ...prev,
      [field]: value,
    }));
  }, []);

  const openClientAccountModal = useCallback(() => {
    setClientAccountForm({
      client_name: "",
      email: "",
      mobile_no: "",
    });
    setCreatedClientAccount(null);
    setIsClientAccountModalOpen(true);
  }, []);

  const createClientAccount = useCallback(
    async (event) => {
      event.preventDefault();

      const payload = {
        client_name: clientAccountForm.client_name.trim(),
        email: clientAccountForm.email.trim().toLowerCase(),
        mobile_no: clientAccountForm.mobile_no.trim(),
      };

      if (!payload.client_name || !payload.email || !payload.mobile_no) {
        message.error(
          "Client name, email address and phone number are required.",
        );
        return;
      }

      if (!/^65\d+$/.test(payload.mobile_no)) {
        message.error(
          "Phone number must start with 65 and contain digits only.",
        );
        return;
      }

      if (!supportToken) {
        message.error("Support session expired. Please login again.");
        history.push("/support-login");
        return;
      }

      setIsCreatingClientAccount(true);
      setCreatedClientAccount(null);
      try {
        const response = await fetch(
          "https://www.smart-lend.com/api/support/borrowers/create-account",
          {
            method: "POST",
            headers: {
              Authorization: `Bearer ${supportToken}`,
              Accept: "application/json",
              "Content-Type": "application/json",
            },
            body: JSON.stringify(payload),
          },
        );
        const data = await response.json();
        if (!response.ok) {
          throw new Error(data?.message || "Unable to create client account.");
        }

        setCreatedClientAccount({
          ...data.user,
          generated_password: data.generated_password,
        });
        setClientAccountForm({
          client_name: "",
          email: "",
          mobile_no: "",
        });
        message.success("Client account created.");
        fetchBorrowers({
          page: 1,
          perPage: borrowersPerPage,
          search: searchTerm,
        });
      } catch (err) {
        message.error(err.message || "Unable to create client account.");
      } finally {
        setIsCreatingClientAccount(false);
      }
    },
    [
      borrowersPerPage,
      clientAccountForm,
      fetchBorrowers,
      history,
      searchTerm,
      supportToken,
    ],
  );

  useEffect(() => {
    if (!supportToken || isLoanRequestOnlySupportUser) return;

    const timer = setTimeout(() => {
      setBorrowerPage(1);
      fetchBorrowers({
        page: 1,
        perPage: borrowersPerPage,
        search: searchTerm,
      });
    }, 300);

    return () => clearTimeout(timer);
  }, [
    borrowersPerPage,
    fetchBorrowers,
    isLoanRequestOnlySupportUser,
    searchTerm,
    supportToken,
  ]);

  useEffect(() => {
    if (
      !supportToken ||
      isLoanRequestOnlySupportUser ||
      activeView !== "property-campaign-leads"
    ) {
      return;
    }

    const timer = setTimeout(() => {
      fetchPropertyCampaignLeads(propertyCampaignLeadSearch);
    }, 250);

    return () => clearTimeout(timer);
  }, [
    activeView,
    fetchPropertyCampaignLeads,
    isLoanRequestOnlySupportUser,
    propertyCampaignLeadSearch,
    supportToken,
  ]);

  useEffect(() => {
    if (!supportToken) {
      history.push("/support-login");
      return;
    }
    if (isLoanRequestOnlySupportUser) return;

    const interval = setInterval(
      () =>
        fetchBorrowers({
          background: true,
          page: borrowerPage,
          perPage: borrowersPerPage,
          search: searchTerm,
        }),
      30000,
    );

    return () => clearInterval(interval);
  }, [
    borrowerPage,
    borrowersPerPage,
    fetchBorrowers,
    history,
    isLoanRequestOnlySupportUser,
    searchTerm,
    supportToken,
  ]);

  const startSupportSync = async (borrower, syncType) => {
    if (!borrower?.user_id || !supportToken) {
      message.error("Support session expired. Please login again.");
      return;
    }

    setSyncingBorrowerId(borrower.user_id);

    try {
      Cookies.set(
        supportSyncCookieKey,
        JSON.stringify({
          source: "cs-dashboard",
          type: syncType,
          borrower_id: borrower.user_id,
        }),
        { path: "/" },
      );

      if (syncType === "singpass") {
        const response = await fetch(
          "https://www.smart-lend.com/api/support/sync/myinfo/url",
          {
            method: "POST",
            headers: {
              "Content-Type": "application/json",
              Authorization: `Bearer ${supportToken}`,
            },
          },
        );

        const data = await response.json();
        if (!response.ok || !data?.singpass_url || !data?.session_id) {
          throw new Error(data?.message || "Unable to start Singpass sync.");
        }

        Cookies.set("latest_session_id", data.session_id, { path: "/" });
        window.location.href = data.singpass_url;
        return;
      }

      const response = await fetch(
        "https://www.smart-lend.com/api/support/sync/corppass/url",
        {
          headers: {
            Authorization: `Bearer ${supportToken}`,
            Accept: "application/json",
          },
        },
      );
      const data = await response.json();

      if (!response.ok || !data?.url) {
        throw new Error(data?.message || "Unable to start CorpPass sync.");
      }

      window.location.href = data.url;
    } catch (err) {
      clearSupportSyncContext();
      message.error(err.message || "Unable to start sync.");
    } finally {
      setSyncingBorrowerId(null);
    }
  };

  useEffect(() => {
    const currentURL = new URL(window.location.href);
    const code = currentURL.searchParams.get("code");
    const state = currentURL.searchParams.get("state");
    const error = currentURL.searchParams.get("error");

    if ((!code && !error) || !supportToken) {
      return;
    }

    const syncContextRaw = Cookies.get(supportSyncCookieKey);
    if (!syncContextRaw) {
      return;
    }

    let syncContext = null;
    try {
      syncContext = JSON.parse(syncContextRaw);
    } catch (err) {
      clearSupportSyncContext();
      return;
    }

    if (syncContext?.source !== "cs-dashboard" || !syncContext?.borrower_id) {
      clearSupportSyncContext();
      return;
    }

    const completeSync = async () => {
      try {
        if (error) {
          throw new Error("Sync was cancelled or failed at provider.");
        }

        if (!code || !state) {
          throw new Error("Missing code/state from callback.");
        }

        if (syncContext.type === "singpass") {
          const sessionId = Cookies.get("latest_session_id");
          if (!sessionId) {
            throw new Error("Missing Singpass session id.");
          }

          const response = await fetch(
            "https://www.smart-lend.com/api/support/sync/myinfo/resolve",
            {
              method: "POST",
              headers: {
                "Content-Type": "application/json",
                Authorization: `Bearer ${supportToken}`,
              },
              body: JSON.stringify({
                borrower_id: syncContext.borrower_id,
                code,
                state,
                session_id: sessionId,
              }),
            },
          );
          const data = await response.json();
          if (!response.ok) {
            throw new Error(
              data?.message || "Unable to resolve Singpass sync.",
            );
          }
          message.success("Singpass data synced to borrower successfully.");
        } else if (syncContext.type === "corppass") {
          const response = await fetch(
            "https://www.smart-lend.com/api/support/sync/corppass/resolve",
            {
              method: "POST",
              headers: {
                "Content-Type": "application/json",
                Authorization: `Bearer ${supportToken}`,
              },
              body: JSON.stringify({
                borrower_id: syncContext.borrower_id,
                code,
                state,
              }),
            },
          );
          const data = await response.json();
          if (!response.ok) {
            throw new Error(
              data?.message || "Unable to resolve CorpPass sync.",
            );
          }
          message.success("CorpPass data synced to borrower successfully.");
        }

        fetchBorrowers({
          background: true,
          page: borrowerPage,
          perPage: borrowersPerPage,
          search: searchTerm,
        });
      } catch (err) {
        message.error(err.message || "Unable to complete support sync.");
      } finally {
        clearSupportSyncContext();
        Cookies.remove("latest_session_id", { path: "/" });
        Cookies.remove("latest_session_id");
        currentURL.searchParams.delete("code");
        currentURL.searchParams.delete("state");
        currentURL.searchParams.delete("error");
        window.history.replaceState({}, document.title, currentURL.toString());
      }
    };

    completeSync();
  }, [
    borrowerPage,
    borrowersPerPage,
    clearSupportSyncContext,
    fetchBorrowers,
    searchTerm,
    supportToken,
  ]);

  const assignToMe = async (borrowerId) => {
    try {
      const employeeId = Cookies.get("support_employee_id");
      await fetch("https://www.smart-lend.com/api/support/assignBorrower", {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
        },
        body: JSON.stringify({
          borrower_id: borrowerId,
          employee_id: parseFloat(employeeId),
        }),
      });
      fetchBorrowers({
        background: true,
        page: borrowerPage,
        perPage: borrowersPerPage,
        search: searchTerm,
      });
    } catch (err) {
      // fail silently for now
    }
  };

  const updateSupportStatus = async (
    borrowerId,
    status,
    followUpDate = null,
  ) => {
    if (!borrowerId || !status) return false;
    try {
      const response = await fetch(
        "https://www.smart-lend.com/api/support/borrowers/status",
        {
          method: "POST",
          headers: {
            "Content-Type": "application/json",
            Authorization: `Bearer ${supportToken}`,
          },
          body: JSON.stringify({
            borrower_id: borrowerId,
            support_status: status,
            support_follow_up_date:
              status === "Following Up" && followUpDate ? followUpDate : null,
          }),
        },
      );

      if (!response.ok) {
        return false;
      }

      const data = await response.json().catch(() => ({}));
      const nextFollowUpDate =
        status === "Following Up"
          ? data?.support_follow_up_date || followUpDate || null
          : null;

      setBorrowers((prev) =>
        prev.map((borrower) =>
          borrower.user_id === borrowerId
            ? {
                ...borrower,
                support_status: status,
                support_follow_up_date: nextFollowUpDate,
                assignment_needs_response: false,
              }
            : borrower,
        ),
      );
      if (selectedBorrower?.user_id === borrowerId) {
        setSelectedBorrower((prev) =>
          prev
            ? {
                ...prev,
                support_status: status,
                support_follow_up_date: nextFollowUpDate,
              }
            : prev,
        );
      }

      return true;
    } catch (err) {
      return false;
    }
  };

  const toggleFavouriteBorrower = async (borrower) => {
    if (!borrower?.user_id || !supportToken) {
      message.error("Support session expired. Please login again.");
      return;
    }

    const nextFavourite = !borrower.support_is_favourite;
    setBorrowers((prev) =>
      prev.map((item) =>
        item.user_id === borrower.user_id
          ? { ...item, support_is_favourite: nextFavourite }
          : item,
      ),
    );

    try {
      const response = await fetch(
        "https://www.smart-lend.com/api/support/borrowers/favourite",
        {
          method: "POST",
          headers: {
            "Content-Type": "application/json",
            Authorization: `Bearer ${supportToken}`,
          },
          body: JSON.stringify({
            borrower_id: borrower.user_id,
            support_is_favourite: nextFavourite,
          }),
        },
      );

      if (!response.ok) {
        throw new Error("Unable to update favourite.");
      }

      const data = await response.json().catch(() => ({}));
      const savedFavourite =
        data?.support_is_favourite === undefined
          ? nextFavourite
          : Boolean(data.support_is_favourite);

      setBorrowers((prev) =>
        prev.map((item) =>
          item.user_id === borrower.user_id
            ? { ...item, support_is_favourite: savedFavourite }
            : item,
        ),
      );
      if (selectedBorrower?.user_id === borrower.user_id) {
        setSelectedBorrower((prev) =>
          prev ? { ...prev, support_is_favourite: savedFavourite } : prev,
        );
      }
    } catch (err) {
      setBorrowers((prev) =>
        prev.map((item) =>
          item.user_id === borrower.user_id
            ? { ...item, support_is_favourite: borrower.support_is_favourite }
            : item,
        ),
      );
      message.error(err.message || "Unable to update favourite.");
    }
  };

  const updateCaseViewStatus = async (
    caseItem,
    status,
    followUpDate = null,
  ) => {
    if (!caseItem?.id || !caseItem?.borrower_id || !status) return;

    setCaseViewUpdatingStatusCaseId(caseItem.id);
    try {
      const didUpdate = await updateSupportStatus(
        caseItem.borrower_id,
        status,
        followUpDate,
      );
      if (!didUpdate) {
        message.error("Unable to update client status.");
        return;
      }

      await loadCaseBoard({ preserveExpansion: true });
      message.success("Client status updated.");
    } finally {
      setCaseViewUpdatingStatusCaseId((current) =>
        current === caseItem.id ? null : current,
      );
    }
  };

  const loadRemarks = async (borrowerId) => {
    try {
      const response = await fetch(
        "https://www.smart-lend.com/api/support/remarks/list",
        {
          method: "POST",
          headers: {
            "Content-Type": "application/json",
            Authorization: `Bearer ${supportToken}`,
          },
          body: JSON.stringify({ borrower_id: borrowerId }),
        },
      );

      if (!response.ok) {
        return;
      }

      const data = await response.json();
      setRemarks(data.remarks || []);
    } catch (err) {
      // no-op
    }
  };

  const addRemark = async (borrowerId) => {
    if (!borrowerId || !newRemark.trim()) return;
    setIsSavingRemark(true);
    try {
      const response = await fetch(
        "https://www.smart-lend.com/api/support/remarks/add",
        {
          method: "POST",
          headers: {
            "Content-Type": "application/json",
            Authorization: `Bearer ${supportToken}`,
          },
          body: JSON.stringify({
            borrower_id: borrowerId,
            remark: newRemark.trim(),
            author_type: "employee",
            author_id: Cookies.get("support_employee_id"),
          }),
        },
      );

      if (response.ok) {
        const data = await response.json();
        setNewRemark("");
        loadRemarks(borrowerId);
        setBorrowers((prev) =>
          prev.map((borrower) =>
            borrower.user_id === borrowerId
              ? {
                  ...borrower,
                  latest_remark: data?.remark || borrower.latest_remark,
                  assignment_needs_response: false,
                }
              : borrower,
          ),
        );
      }
    } catch (err) {
      // ignore
    } finally {
      setIsSavingRemark(false);
    }
  };

  const portBorrowerToCrm = async (borrower, source) => {
    const key = `${borrower.user_id}:${source}`;
    if (crmImportsInFlight.current.has(key)) return;
    crmImportsInFlight.current.add(key);
    setCrmImports((previous) => ({ ...previous, [key]: { loading: true } }));
    const storageKey = `support-crm-import:${key}`;
    let diagnostics = null;
    try {
      // Persist only request metadata in this tab, never provider data or CRM credentials.
      let pending;
      try {
        pending = JSON.parse(sessionStorage.getItem(storageKey) || "null");
      } catch {
        pending = null;
      }
      if (
        !pending?.requestId ||
        Date.now() - pending.createdAt > 23 * 60 * 60 * 1000
      ) {
        pending = { requestId: crypto.randomUUID(), createdAt: Date.now() };
        sessionStorage.setItem(storageKey, JSON.stringify(pending));
      }
      const response = await fetch(
        `https://www.smart-lend.com/api/support/borrowers/${encodeURIComponent(borrower.user_id)}/crm/${source}`,
        {
          method: "POST",
          headers: {
            Authorization: `Bearer ${supportToken}`,
            "Content-Type": "application/json",
            Accept: "application/json",
          },
          body: JSON.stringify({ request_id: pending.requestId }),
        },
      );
      const result = await response.json();
      if (!response.ok || result.ok !== true) {
        diagnostics = result.diagnostics || null;
        if (
          result.retryable === false ||
          (response.status < 500 && ![423, 429].includes(response.status))
        ) {
          sessionStorage.removeItem(storageKey);
        }
        throw new Error(
          result.message || "Unable to port this client to CRM. Please retry.",
        );
      }
      sessionStorage.removeItem(storageKey);
      const successMessage = `${source === "myinfo" ? "MyInfo" : "CorpPass"} saved to CRM (client #${result.data.client_id}).`;
      setCrmImports((previous) => ({
        ...previous,
        [key]: { message: successMessage },
      }));
      message.success(successMessage);
    } catch (error) {
      const errorMessage =
        error.message === "Failed to fetch"
          ? "Connection failed. Click the port button again to safely retry the same import."
          : error.message || "Unable to port this client to CRM. Please retry.";
      setCrmImports((previous) => ({
        ...previous,
        [key]: { error: errorMessage, diagnostics },
      }));
      message.error(errorMessage);
    } finally {
      crmImportsInFlight.current.delete(key);
    }
  };

  const fetchBorrowerProfile = async (borrower) => {
    setIsProfileLoading(true);
    setError("");
    try {
      const response = await fetch(
        `https://www.smart-lend.com/api/support/borrowers/${borrower.user_id}`,
        {
          headers: {
            Authorization: `Bearer ${supportToken}`,
            Accept: "application/json",
          },
        },
      );

      if (!response.ok) {
        const message = await response.json();
        throw new Error(message?.message || "Unable to load borrower profile");
      }

      const data = await response.json();
      const parsedSingpassData = parseMaybeJson(data.singpass_data);
      const parsedMyinfoData =
        parseMaybeJson(data.myinfo_data) ||
        parseMaybeJson(data.borrower?.myinfo_data);
      setSelectedBorrowerProfile(data.borrower);
      setSelectedBorrower((prev) => {
        if (!prev || String(prev.user_id) !== String(borrower.user_id)) {
          return prev;
        }

        return {
          ...prev,
          ...data.borrower,
          borrower_display_name:
            data.borrower?.borrower_display_name ||
            data.borrower?.company_name ||
            prev.borrower_display_name ||
            prev.company_name,
        };
      });
      setViewingUser(data.borrower?.user_id);
      setSingpassData(parsedSingpassData || null);
      setMyinfoData(parsedSingpassData ? null : parsedMyinfoData || null);
      setCombinedSingpassData(
        [parsedSingpassData, ...(data.other_authorisers || [])].filter(Boolean),
      );
      setLiveUserData(parsedSingpassData || null);
      setAllCBSData(
        data.credit_report_data
          ? [
              {
                name:
                  getPersonData(parsedSingpassData)?.name?.value ||
                  parsedMyinfoData?.name?.value ||
                  getPersonData(parsedMyinfoData)?.name?.value ||
                  getBorrowerDisplayName(data.borrower),
                cbs_data: data.credit_report_data,
              },
            ]
          : [],
      );
      setBackupContact(data.borrower?.user_id || "");
      setKeyman(data.latest_keyman || "");
      setBadgeVerified(!!data.borrower?.badge_verified);
      setViewingTab(0);
      loadRemarks(borrower.user_id);
    } catch (err) {
      setError(err.message);
    } finally {
      setIsProfileLoading(false);
    }
  };

  const loadBorrowerCases = useCallback(
    async (borrowerId) => {
      if (!borrowerId) return;
      try {
        const response = await fetch(
          `https://www.smart-lend.com/api/support/borrowers/${borrowerId}/cases`,
          {
            headers: {
              Authorization: `Bearer ${supportToken}`,
              Accept: "application/json",
            },
          },
        );

        if (!response.ok) {
          return;
        }

        const data = await response.json();
        setBorrowerCases(data.cases || []);
      } catch (err) {
        // no-op
      }
    },
    [supportToken],
  );

  const loadCaseTimeline = useCallback(
    async (caseId) => {
      if (!caseId) return;
      try {
        const response = await fetch(
          `https://www.smart-lend.com/api/support/cases/${caseId}/timeline`,
          {
            headers: {
              Authorization: `Bearer ${supportToken}`,
              Accept: "application/json",
            },
          },
        );

        if (!response.ok) {
          return;
        }

        const data = await response.json();
        setCaseTimeline(data.timeline || []);
      } catch (err) {
        // no-op
      }
    },
    [supportToken],
  );

  const openCreateCaseModal = async (borrower) => {
    setCaseBorrower(borrower);
    setSelectedCaseProduct("money_lender");
    setSelectedCase(null);
    setCaseTimeline([]);
    setNewCaseRemark("");
    setCaseDocumentFile(null);
    setCaseDocumentRemark("");
    await loadBorrowerCases(borrower.user_id);
  };

  const closeCreateCaseModal = () => {
    setCaseBorrower(null);
    setSelectedCaseProduct("money_lender");
    setBorrowerCases([]);
    setSelectedCase(null);
    setCaseTimeline([]);
    setNewCaseRemark("");
    setCaseDocumentFile(null);
    setCaseDocumentRemark("");
  };

  const openCreateLoanModal = (borrower) => {
    setCreateLoanBorrower(borrower);
    setCreateLoanForm({
      ...createLoanInitialForm(),
      contact_email: borrower?.email || "",
      contact_phone: borrower?.mobile_no || "",
    });
  };

  const closeCreateLoanModal = (force = false) => {
    if (isCreatingLoan && !force) return;
    setCreateLoanBorrower(null);
    setCreateLoanForm(createLoanInitialForm());
  };

  const updateCreateLoanField = (field, value) => {
    setCreateLoanForm((prev) => ({ ...prev, [field]: value }));
  };

  const updateCreateLoanFiles = (field, files) => {
    setCreateLoanForm((prev) => ({
      ...prev,
      [field]: Array.from(files || []),
    }));
  };

  const submitSupportLoan = async () => {
    if (!createLoanBorrower?.user_id || !supportToken) {
      message.error("Support session expired. Please login again.");
      return;
    }

    const amount = Number(createLoanForm.amount);
    const tenor = Number(createLoanForm.tenor_months);
    if (!Number.isFinite(amount) || amount <= 0) {
      message.error("Enter a valid loan amount.");
      return;
    }
    if (!Number.isInteger(tenor) || tenor <= 0) {
      message.error("Enter a valid tenor in months.");
      return;
    }
    const formData = new FormData();
    [
      "loan_type",
      "case_type",
      "amount",
      "tenor_months",
      "desired_rate_pa",
      "corporate_interest_rate",
      "contact_email",
      "contact_phone",
      "notes",
    ].forEach((field) => {
      if (createLoanForm[field] !== undefined && createLoanForm[field] !== "") {
        formData.append(field, createLoanForm[field]);
      }
    });
    if (createLoanForm.cbs_report) {
      formData.append("cbs_report", createLoanForm.cbs_report);
    }
    if (createLoanForm.mlcb_report) {
      formData.append("mlcb_report", createLoanForm.mlcb_report);
    }
    createLoanForm.payslips.forEach((file) => {
      formData.append("payslips[]", file);
    });
    createLoanForm.bank_statements.forEach((file) => {
      formData.append("bank_statements[]", file);
    });

    setIsCreatingLoan(true);
    try {
      const response = await fetch(
        `https://www.smart-lend.com/api/support/borrowers/${createLoanBorrower.user_id}/loans/create`,
        {
          method: "POST",
          headers: {
            Authorization: `Bearer ${supportToken}`,
            Accept: "application/json",
          },
          body: formData,
        },
      );
      const data = await response.json();
      if (!response.ok) {
        throw new Error(data?.message || "Unable to create loan.");
      }
      message.success(data?.message || "Loan created successfully.");
      closeCreateLoanModal(true);
      fetchBorrowers({
        background: true,
        page: borrowerPage,
        perPage: borrowersPerPage,
        search: searchTerm,
      });
    } catch (err) {
      message.error(err.message || "Unable to create loan.");
    } finally {
      setIsCreatingLoan(false);
    }
  };

  const createSupportCase = async () => {
    if (!caseBorrower?.user_id) return;

    setIsCreatingCase(true);
    try {
      const response = await fetch(
        "https://www.smart-lend.com/api/support/cases/create",
        {
          method: "POST",
          headers: {
            "Content-Type": "application/json",
            Authorization: `Bearer ${supportToken}`,
          },
          body: JSON.stringify({
            borrower_id: caseBorrower.user_id,
            product: selectedCaseProduct,
          }),
        },
      );

      const data = await response.json();

      if (!response.ok) {
        message.error(data?.message || "Unable to create case.");
        return;
      }

      message.success("Case created successfully.");
      await loadBorrowerCases(caseBorrower.user_id);
      if (data?.case?.id) {
        setSelectedCase(data.case);
        loadCaseTimeline(data.case.id);
      }
    } catch (err) {
      message.error("Unable to create case.");
    } finally {
      setIsCreatingCase(false);
    }
  };

  const addCaseRemarkToCase = async (caseId, remark, options = {}) => {
    const trimmedRemark = (remark || "").trim();
    if (!caseId || !trimmedRemark) return false;

    const { fromCaseView = false } = options;
    if (fromCaseView) {
      setCaseViewSavingRemarkCaseId(caseId);
    } else {
      setIsSavingCaseRemark(true);
    }

    try {
      const response = await fetch(
        `https://www.smart-lend.com/api/support/cases/${caseId}/remarks`,
        {
          method: "POST",
          headers: {
            "Content-Type": "application/json",
            Authorization: `Bearer ${supportToken}`,
          },
          body: JSON.stringify({ remark: trimmedRemark }),
        },
      );

      if (!response.ok) {
        message.error("Unable to add remark.");
        return false;
      }

      if (fromCaseView) {
        setCaseViewRemarkDrafts((prev) => ({ ...prev, [caseId]: "" }));
        loadCaseBoard({ preserveExpansion: true });
      } else {
        setNewCaseRemark("");
        loadCaseTimeline(caseId);
      }

      return true;
    } catch (err) {
      message.error("Unable to add remark.");
      return false;
    } finally {
      if (fromCaseView) {
        setCaseViewSavingRemarkCaseId((current) =>
          current === caseId ? null : current,
        );
      } else {
        setIsSavingCaseRemark(false);
      }
    }
  };

  const uploadDocumentToCase = async (caseId, file, remark, options = {}) => {
    if (!caseId || !file) return false;

    const { fromCaseView = false } = options;
    if (fromCaseView) {
      setCaseViewUploadingDocCaseId(caseId);
    } else {
      setIsUploadingCaseDocument(true);
    }

    try {
      const formData = new FormData();
      formData.append("document", file);
      formData.append("remark", remark || "");

      const response = await fetch(
        `https://www.smart-lend.com/api/support/cases/${caseId}/documents`,
        {
          method: "POST",
          headers: {
            Authorization: `Bearer ${supportToken}`,
          },
          body: formData,
        },
      );

      if (!response.ok) {
        message.error("Unable to upload document.");
        return false;
      }

      if (fromCaseView) {
        setCaseViewDocumentFiles((prev) => ({ ...prev, [caseId]: null }));
        setCaseViewDocumentRemarks((prev) => ({ ...prev, [caseId]: "" }));
        loadCaseBoard({ preserveExpansion: true });
      } else {
        setCaseDocumentFile(null);
        setCaseDocumentRemark("");
        loadCaseTimeline(caseId);
      }

      return true;
    } catch (err) {
      message.error("Unable to upload document.");
      return false;
    } finally {
      if (fromCaseView) {
        setCaseViewUploadingDocCaseId((current) =>
          current === caseId ? null : current,
        );
      } else {
        setIsUploadingCaseDocument(false);
      }
    }
  };

  const deleteSupportCaseById = async (caseId, options = {}) => {
    if (!caseId) return false;

    const { fromCaseView = false } = options;
    setDeletingCaseId(caseId);

    try {
      const response = await fetch(
        `https://www.smart-lend.com/api/support/cases/${caseId}`,
        {
          method: "DELETE",
          headers: {
            Authorization: `Bearer ${supportToken}`,
            Accept: "application/json",
          },
        },
      );

      const data = await response.json().catch(() => ({}));

      if (!response.ok) {
        message.error(data?.message || "Unable to delete case.");
        return false;
      }

      message.success("Case deleted.");

      if (fromCaseView) {
        loadCaseBoard({ preserveExpansion: true });
      } else {
        const nextCases = borrowerCases.filter((item) => item.id !== caseId);
        setBorrowerCases(nextCases);
        if (selectedCase?.id === caseId) {
          setSelectedCase(nextCases[0] || null);
          setCaseTimeline([]);
          if (nextCases[0]?.id) {
            loadCaseTimeline(nextCases[0].id);
          }
        }
      }

      return true;
    } catch (err) {
      message.error("Unable to delete case.");
      return false;
    } finally {
      setDeletingCaseId((current) => (current === caseId ? null : current));
    }
  };

  const loadBorrowerLoans = useCallback(
    async (borrowerId) => {
      if (!borrowerId) return [];
      setIsLoadingAvailableLoans(true);
      try {
        const response = await fetch(
          `https://www.smart-lend.com/api/support/borrowers/${borrowerId}/loans`,
          {
            headers: {
              Authorization: `Bearer ${supportToken}`,
              Accept: "application/json",
            },
          },
        );

        if (!response.ok) {
          return [];
        }

        const data = await response.json();
        const loans = data.loans || [];
        setAvailableLoans(loans);
        return loans;
      } catch (err) {
        return [];
      } finally {
        setIsLoadingAvailableLoans(false);
      }
    },
    [supportToken],
  );

  const openTagLoanModal = async (caseId, borrowerId) => {
    if (!caseId || !borrowerId) return;
    setTagLoanModal({ open: true, caseId, borrowerId });
    setAvailableLoans([]);
    await loadBorrowerLoans(borrowerId);
  };

  const closeTagLoanModal = () => {
    setTagLoanModal({ open: false, caseId: null, borrowerId: null });
    setAvailableLoans([]);
  };

  const tagLoanToCase = async (caseId, borrowerId, loan) => {
    if (!caseId || !borrowerId || !loan?.id || !loan?.loan_type) return false;

    setTaggingLoanCaseId(caseId);
    try {
      const response = await fetch(
        `https://www.smart-lend.com/api/support/cases/${caseId}/tag-loan`,
        {
          method: "POST",
          headers: {
            "Content-Type": "application/json",
            Authorization: `Bearer ${supportToken}`,
          },
          body: JSON.stringify({
            loan_type: loan.loan_type,
            loan_request_id: loan.id,
          }),
        },
      );

      const data = await response.json().catch(() => ({}));

      if (!response.ok) {
        message.error(data?.message || "Unable to tag loan.");
        return false;
      }

      message.success("Loan tagged to case.");
      if (caseBorrower?.user_id === borrowerId) {
        await loadBorrowerCases(borrowerId);
      }
      await loadCaseBoard({ preserveExpansion: true });
      if (selectedCase?.id === caseId) {
        await loadCaseTimeline(caseId);
      }
      closeTagLoanModal();
      return true;
    } catch (err) {
      message.error("Unable to tag loan.");
      return false;
    } finally {
      setTaggingLoanCaseId((current) => (current === caseId ? null : current));
    }
  };

  const addCaseRemark = async () => {
    if (!selectedCase?.id || !newCaseRemark.trim()) return;
    await addCaseRemarkToCase(selectedCase.id, newCaseRemark);
  };

  const uploadCaseDocument = async () => {
    if (!selectedCase?.id || !caseDocumentFile) return;
    await uploadDocumentToCase(
      selectedCase.id,
      caseDocumentFile,
      caseDocumentRemark,
    );
  };

  const loadCaseBoard = useCallback(
    async (options = {}) => {
      const { preserveExpansion = false } = options;
      setIsCaseBoardLoading(true);
      try {
        const response = await fetch(
          "https://www.smart-lend.com/api/support/cases/board",
          {
            headers: {
              Authorization: `Bearer ${supportToken}`,
              Accept: "application/json",
            },
          },
        );

        if (!response.ok) {
          const data = await response.json().catch(() => ({}));
          message.error(data?.message || "Unable to load case view.");
          return;
        }

        const data = await response.json();
        const nextStatuses = data.statuses || [];
        setCaseBoardStatuses(nextStatuses);

        if (preserveExpansion) {
          const validStatuses = new Set(
            nextStatuses.map((statusGroup) => statusGroup.status),
          );
          const validCaseIds = new Set(
            nextStatuses.flatMap((statusGroup) =>
              (statusGroup.cases || []).map((caseItem) => caseItem.id),
            ),
          );

          setExpandedStatuses((prev) => {
            const next = {};
            Object.entries(prev).forEach(([status, isOpen]) => {
              if (isOpen && validStatuses.has(status)) {
                next[status] = true;
              }
            });
            return next;
          });

          setExpandedCases((prev) => {
            const next = {};
            Object.entries(prev).forEach(([caseId, isOpen]) => {
              const parsedCaseId = Number(caseId);
              if (isOpen && validCaseIds.has(parsedCaseId)) {
                next[parsedCaseId] = true;
              }
            });
            return next;
          });
          return;
        }

        setExpandedStatuses({});
        setExpandedCases({});
        setCaseViewRemarkDrafts({});
        setCaseViewDocumentFiles({});
        setCaseViewDocumentRemarks({});
      } catch (err) {
        message.error("Unable to load case view.");
      } finally {
        setIsCaseBoardLoading(false);
      }
    },
    [supportToken],
  );

  const openRemarkModal = (borrower) => {
    setRemarkBorrower(borrower);
    setNewRemark("");
    loadRemarks(borrower.user_id);
  };

  const openBorrowerDetailsFromCaseView = (caseItem) => {
    if (!caseItem?.borrower_id) return;

    const matchingBorrower = borrowers.find(
      (borrower) => borrower.user_id === caseItem.borrower_id,
    );

    const borrowerForModal = matchingBorrower || {
      user_id: caseItem.borrower_id,
      company_name: caseItem.company_name,
    };

    setSelectedBorrower(borrowerForModal);
    fetchBorrowerProfile(borrowerForModal);
  };

  const closeRemarkModal = () => {
    setRemarkBorrower(null);
    setRemarks([]);
    setNewRemark("");
  };

  const closeModal = () => {
    setSelectedBorrower(null);
    setSelectedBorrowerProfile(null);
    setRemarks([]);
    setNewRemark("");
    setShowCbsUploader(false);
    setCreditReportFile(null);
    setCreditFile(null);
  };

  const closeAssigneeModal = () => {
    setIsAssigneeModalOpen(false);
    setAssigneeStep(1);
    setAssigneeTarget(null);
    setSelectedAssigneeId("");
    setAssigneeRemark("");
    setIsAssigningBorrower(false);
  };

  const fetchAssignees = async () => {
    if (!supportToken) return;
    try {
      const response = await fetch(
        "https://www.smart-lend.com/api/support/assignees",
        {
          headers: {
            Authorization: `Bearer ${supportToken}`,
            Accept: "application/json",
          },
        },
      );

      if (!response.ok) {
        return;
      }

      const data = await response.json();
      setAssignees(data.assignees || []);
    } catch (err) {
      // no-op
    }
  };

  const openAssigneeModal = (borrower) => {
    setAssigneeTarget(borrower);
    setAssigneeStep(1);
    setSelectedAssigneeId("");
    setAssigneeRemark("");
    setIsAssigneeModalOpen(true);
    fetchAssignees();
  };

  const reassignBorrower = async () => {
    if (!assigneeTarget || !selectedAssigneeId) {
      message.warning("Please select an assignee.");
      return;
    }

    try {
      setIsAssigningBorrower(true);
      const response = await fetch(
        "https://www.smart-lend.com/api/support/reassignBorrower",
        {
          method: "POST",
          headers: {
            "Content-Type": "application/json",
            Authorization: `Bearer ${supportToken}`,
          },
          body: JSON.stringify({
            borrower_id: assigneeTarget.user_id,
            employee_id: parseFloat(selectedAssigneeId),
            remark: assigneeRemark.trim() || null,
          }),
        },
      );

      if (!response.ok) {
        message.error("Unable to reassign borrower");
        return;
      }

      message.success("Borrower reassigned");
      fetchBorrowers({
        background: true,
        page: borrowerPage,
        perPage: borrowersPerPage,
        search: searchTerm,
      });
      if (selectedBorrower?.user_id === assigneeTarget.user_id) {
        fetchBorrowerProfile(assigneeTarget);
        loadRemarks(assigneeTarget.user_id);
      }
      closeAssigneeModal();
    } catch (err) {
      message.error("Unable to reassign borrower");
    } finally {
      setIsAssigningBorrower(false);
    }
  };

  const extractText = (file) => {
    pdfToText(file)
      .then((text) => {
        setCreditFile(text);
      })
      .catch(() => {
        message.error("Failed to extract text from PDF");
      });
  };

  const splitStringToRows = (inputString) => {
    const rows = inputString.split(/(?<! ) {2}(?! )/);
    return rows;
  };

  const extractTextBetween = (beforeText, afterText) => {
    if (creditFile !== null) {
      const beforeTextPattern = beforeText.replace(/\s+/g, "\\s+");
      const afterTextPattern = afterText.replace(/\s+/g, "\\s+");
      const regex = new RegExp(`${beforeTextPattern}(.*?)${afterTextPattern}`);

      const match = creditFile.match(regex);
      if (match && match[1]) {
        return match[1].trim();
      }
      return "Text not found between specified markers";
    }
    return null;
  };

  const removeCharactersAroundPage = (inputString) => {
    const regex = /(.{0,19})page(.{0,7})/g;
    const result = inputString.replace(regex, (match, p1, p2) => {
      const charsToRemoveBefore = 19 - 11;
      const charsToRemoveAfter = 11 - 4;

      const removedStart =
        p1.length > charsToRemoveBefore
          ? p1.slice(0, -charsToRemoveBefore)
          : "";
      const removedEnd =
        p2.length > charsToRemoveAfter ? p2.slice(charsToRemoveAfter) : "";
      return `${removedStart}page${removedEnd}`;
    });

    return result;
  };

  const extractTextBetweeforloandetails = (
    creditText,
    beforeText,
    afterText,
  ) => {
    if (creditText !== null) {
      const startIndex = creditText.indexOf(beforeText);
      if (startIndex === -1) {
        return "Before text not found";
      }

      const adjustedStartIndex = startIndex + beforeText.length;
      const endIndex = creditText.indexOf(afterText, adjustedStartIndex);
      if (endIndex === -1) {
        return "After text not found";
      }

      return creditText.substring(adjustedStartIndex, endIndex);
    }
    return null;
  };

  const uploadCBSReport = async () => {
    if (!creditReportFile || !selectedBorrower?.user_id) {
      message.warning("Select a CBS report file first.");
      return;
    }
    if (!creditFile) {
      message.warning("CBS report text is not ready yet.");
      return;
    }
    if (!supportToken) {
      message.error("Support session expired. Please log in again.");
      return;
    }

    try {
      setIsUploadingCbs(true);
      const formData1 = new FormData();
      formData1.append("credit_report", creditReportFile);

      const targetLine =
        "  account status history product type   grantor bank   account type date opened / date closed   overdue balance last 12 cycles / cash advance / balance transfer full payment  ";

      const getMaxValue = (data) =>
        data.reduce((max, current) => {
          const currentValue = parseFloat(current.value.replace(/,/g, ""));
          return currentValue > max ? currentValue : max;
        }, 0);

      const parseData = (inputString) => {
        const regex =
          /([a-zA-Z]+\s\d{4})\s+All\s+All\s+[\d,.]+\s+([\d,.]+\.\d{2})/g;

        const result = [];
        let match;

        while ((match = regex.exec(inputString)) !== null) {
          const date = match[1];
          const value = match[2];
          result.push({ date, value });
        }

        return result;
      };

      const formatAndMergeString = (input) => {
        const patterns = [
          "unsecured overdraft",
          "unsecured credit card",
          "other",
          "motor vehicle loan",
          "hdb loan",
          "private residential purchase",
          "unsecured personal loan",
        ];

        const regex = new RegExp(`(${patterns.join("|")})`, "g");

        const formattedString = input
          .split(regex)
          .filter(Boolean)
          .map((str) => str.trim())
          .join("\n");

        const lines = formattedString.split("\n");

        const result = [];
        for (let i = 0; i < lines.length; i += 2) {
          if (lines[i + 1]) {
            const record = [lines[i]].concat(
              lines[i + 1].split(/\s{3,}/).map((part) => part.trim()),
            );
            result.push(record);
          } else {
            result.push([lines[i]]);
          }
        }

        return result;
      };

      const hasOverdueBalance = (data) =>
        data.some((item) => {
          const fifthIndex = item[4];
          return !isNaN(fifthIndex) && parseFloat(fifthIndex) > 0;
        });

      const combinePrivateResidentialPurchase = (splitArray) => {
        const combinedArray = [];

        for (let i = 0; i < splitArray.length; i++) {
          if (splitArray[i].includes("private residential purchase")) {
            combinedArray.push(
              splitArray[i] + "  " + (splitArray[i + 1] || ""),
            );
            i += 1;
          } else {
            combinedArray.push(splitArray[i]);
          }
        }

        return combinedArray;
      };

      const splitExactlyTwoSpaces = (inputString) =>
        inputString.split(/(?<! )  (?! )/);

      const combineSingleOrJoint = (splitArray) => {
        const combinedArray = [];

        for (let i = 0; i < splitArray.length; i++) {
          if (
            splitArray[i].startsWith("single") ||
            splitArray[i].startsWith("joint")
          ) {
            if (combinedArray.length > 0) {
              combinedArray[combinedArray.length - 1] += "  " + splitArray[i];
            } else {
              combinedArray.push(splitArray[i]);
            }
          } else {
            combinedArray.push(splitArray[i]);
          }
        }

        return combinedArray;
      };

      const textWithoutPage = removeCharactersAroundPage(
        creditFile.toLowerCase(),
      ).replace(/page/g, "");

      const extract = extractTextBetweeforloandetails(
        textWithoutPage,
        "aggregated outstanding balances  month   product type   grantor bank   secured balances  unsecured balances interest bearing  unsecured balances non-interest bearing  exempted unsecured balances  ",
        "total",
      );

      const extract2ForMonthlyCommitment = extractTextBetweeforloandetails(
        textWithoutPage,
        "aggregated monthly instalment",
        "aggregated monthly instalments for preceding 5 months",
      );

      const extract3ForChartingOutstandingBalance =
        extractTextBetweeforloandetails(
          creditFile,
          "Aggregated Outstanding Balances for Preceding 5 Months",
          "Aggregated Monthly Instalment",
        );
      const chartDate = parseData(extract3ForChartingOutstandingBalance);

      const extract4ForChartingOutstandingBalance =
        extractTextBetweeforloandetails(
          textWithoutPage,
          "aggregated monthly instalment  month   product type   grantor bank   account type**   property***   non-property   unsecured  exempted unsecured  ",
          "aggregated monthly instalments for preceding 5 months",
        );

      const extractEnquiryDate = extractTextBetweeforloandetails(
        textWithoutPage,
        "enquiry date",
        "reference",
      );

      const extract8ForOverdueBalance = extractTextBetweeforloandetails(
        textWithoutPage,
        "account status history",
        "previous enquiries  date ",
      )
        .replace(new RegExp(targetLine, "g"), " ")
        .replace(/account status history/g, "")
        .replace(/product type/g, "")
        .replace(/grantor bank/g, "")
        .replace(/account type/g, "")
        .replace(/date opened \/ date closed/g, "")
        .replace(/overdue balance/g, "")
        .replace(
          /last 12 cycles \/ cash advance \/ balance transfer full payment/g,
          "",
        )
        .trim();

      const creditReportData = {
        EnquiryDate: extractEnquiryDate,
        SecuredCreditLimit:
          creditFile && creditFile !== ""
            ? parseFloat(
                extractTextBetween(
                  "Secured Credit Limit",
                  "Unsecured Credit Limit",
                ).replace(/,/g, ""),
              )
            : null,
        UnsecuredCreditLimit:
          creditFile && creditFile !== ""
            ? parseFloat(
                extractTextBetween(
                  "Unsecured Credit Limit",
                  "Exempted Credit Limit",
                ).replace(/,/g, ""),
              )
            : null,
        CreditScore:
          creditFile && creditFile !== ""
            ? parseFloat(
                extractTextBetween(
                  "financial institution.  Score",
                  "Risk Grade",
                ),
              )
            : null,
        RiskGrade:
          creditFile && creditFile !== ""
            ? extractTextBetween("Risk Grade ", "Risk Grade Description", null)
            : null,
        ProbabilityofDefault:
          creditFile && creditFile !== ""
            ? parseFloat(
                extractTextBetween(
                  "Probability of Default ",
                  " For more details on the description",
                ).replace(/,/g, ""),
              )
            : null,
        SecuredCreditUtilized:
          creditFile && creditFile !== ""
            ? extractTextBetween(
                "Total  ",
                " Aggregated Outstanding Balances for Preceding 5 Months",
                null,
              )
                ?.split("  ")
                ?.map((num) => parseFloat(num.replace(/,/g, "")))[0]
            : null,
        UnsecuredCreditUtilized:
          creditFile && creditFile !== ""
            ? extractTextBetween(
                "Total  ",
                " Aggregated Outstanding Balances for Preceding 5 Months",
                null,
              )
                ?.split("  ")
                ?.map((num) => parseFloat(num.replace(/,/g, "")))[1]
            : null,
        SecuredCreditUtilizationinpercentage:
          creditFile && creditFile !== ""
            ? (
                (extractTextBetween(
                  "Total  ",
                  " Aggregated Outstanding Balances for Preceding 5 Months",
                )
                  ?.split("  ")
                  ?.map((num) => parseFloat(num.replace(/,/g, "")))[0] /
                  parseFloat(
                    extractTextBetween(
                      "Secured Credit Limit",
                      "Unsecured Credit Limit",
                      null,
                    )?.replace(/,/g, ""),
                  )) *
                100
              )?.toFixed(2)
            : null,
        UnsecuredCreditUtilizationinpercentage:
          creditFile && creditFile !== ""
            ? (
                (extractTextBetween(
                  "Total  ",
                  " Aggregated Outstanding Balances for Preceding 5 Months",
                )
                  ?.split("  ")
                  ?.map((num) => parseFloat(num.replace(/,/g, "")))[1] /
                  parseFloat(
                    extractTextBetween(
                      "Unsecured Credit Limit",
                      "Exempted Credit Limit",
                      null,
                    )?.replace(/,/g, ""),
                  )) *
                100
              )?.toFixed(2)
            : null,
        MonthlyCommitment: (
          parseFloat(
            extract2ForMonthlyCommitment
              .trim()
              .split("   ")
              [
                extract2ForMonthlyCommitment.trim().split("   ").length - 4
              ]?.replace(/,/g, ""),
          ) +
          parseFloat(
            extract2ForMonthlyCommitment
              .trim()
              .split("   ")
              [
                extract2ForMonthlyCommitment.trim().split("   ").length - 3
              ]?.replace(/,/g, ""),
          )
        ).toLocaleString("en-US", {
          style: "currency",
          currency: "SGD",
        }),
        NoteworthyOngoingLoans:
          splitStringToRows(extract).filter(
            (row) =>
              row.includes("private residential purchase") ||
              row.includes("motor vehicle loan") ||
              row.includes("hdb loan"),
          ) &&
          splitStringToRows(extract).filter(
            (row) =>
              row.includes("private residential purchase") ||
              row.includes("motor vehicle loan") ||
              row.includes("hdb loan"),
          ).length !== 0
            ? splitStringToRows(extract).filter(
                (row) =>
                  row.includes("private residential purchase") ||
                  row.includes("motor vehicle loan") ||
                  row.includes("hdb loan"),
              )
            : null,
        Last6MonthsGraphChartMaxData:
          getMaxValue(chartDate) && chartDate.reverse()
            ? getMaxValue(chartDate)
            : null,
        Last6MonthsGraphChartData:
          getMaxValue(chartDate) && chartDate.reverse()
            ? chartDate.reverse()
            : null,
        CBSImpLoanSupplementaryInstallment: combineSingleOrJoint(
          combinePrivateResidentialPurchase(
            splitExactlyTwoSpaces(extract4ForChartingOutstandingBalance),
          ),
        ).filter(
          (row) =>
            row.includes("private residential purchase") ||
            row.includes("motor vehicle loan") ||
            row.includes("hdb loan"),
        )
          ? combineSingleOrJoint(
              combinePrivateResidentialPurchase(
                splitExactlyTwoSpaces(extract4ForChartingOutstandingBalance),
              ),
            ).filter(
              (row) =>
                row.includes("private residential purchase") ||
                row.includes("motor vehicle loan") ||
                row.includes("hdb loan"),
            )
          : null,
        defaults: parseFloat(
          extractTextBetween("Defaults   ", "  Bankruptcy Proceedings   "),
        ),
        bankcruptcyProceedings: parseFloat(
          extractTextBetween(
            "  Bankruptcy Proceedings   ",
            "  Secured Credit Limit ",
          ),
        ),
        overdueBalance: hasOverdueBalance(
          formatAndMergeString(extract8ForOverdueBalance),
        ),
      };

      formData1.append("credit_report_data", JSON.stringify(creditReportData));
      formData1.append("user_id", `${selectedBorrower.user_id}`);

      const updateBorrowerCreditReport = await fetch(
        `https://www.smart-lend.com/api/support/borrowers/${selectedBorrower.user_id}/credit-report`,
        {
          method: "POST",
          headers: {
            Authorization: `Bearer ${supportToken}`,
          },
          body: formData1,
        },
      );

      if (updateBorrowerCreditReport.status === 200) {
        message.success("CBS Report updated");
        setShowCbsUploader(false);
        setCreditReportFile(null);
        setCreditFile(null);
        fetchBorrowers({
          background: true,
          page: borrowerPage,
          perPage: borrowersPerPage,
          search: searchTerm,
        });
        fetchBorrowerProfile(selectedBorrower);
      } else {
        message.error("Unable to update CBS report");
      }
    } catch (error) {
      message.error("Unable to update CBS report");
    } finally {
      setIsUploadingCbs(false);
    }
  };

  const openCbsReport = async (borrowerId) => {
    if (!supportToken) {
      message.error("Support session expired. Please log in again.");
      return;
    }

    try {
      const response = await fetch(
        `https://www.smart-lend.com/api/support/borrowers/${borrowerId}/credit-report`,
        {
          headers: {
            Authorization: `Bearer ${supportToken}`,
          },
        },
      );

      if (!response.ok) {
        message.error("Unable to open CBS report");
        return;
      }

      const blob = await response.blob();
      const fileUrl = window.URL.createObjectURL(blob);
      window.open(fileUrl, "_blank", "noopener,noreferrer");
      setTimeout(() => window.URL.revokeObjectURL(fileUrl), 10000);
    } catch (err) {
      message.error("Unable to open CBS report");
    }
  };

  const renderBorrowerLoanAndCaseSummary = (borrower) => {
    const chips = [
      {
        label: "Personal",
        enabled: !!borrower.has_personal_loan_request,
      },
      {
        label: "Corporate",
        enabled: !!borrower.has_corporate_loan_request,
      },
      {
        label: "Property",
        enabled: !!borrower.has_property_term_loan_request,
      },
      {
        label: `Cases (${borrower.support_case_count || 0})`,
        enabled: !!borrower.has_support_case,
      },
    ];

    return (
      <div style={{ display: "flex", flexWrap: "wrap", gap: "6px" }}>
        {chips.map((chip) => (
          <span
            key={chip.label}
            style={{
              fontSize: "11px",
              fontWeight: 700,
              padding: "4px 8px",
              borderRadius: "999px",
              border: `1px solid ${chip.enabled ? "#52c41a" : "#d9d9d9"}`,
              background: chip.enabled ? "#f6ffed" : "#fafafa",
              color: chip.enabled ? "#237804" : "#8c8c8c",
            }}
          >
            {chip.label}
          </span>
        ))}
      </div>
    );
  };

  const formatDate = (value) => {
    if (!value) return "-";
    const date = new Date(value);
    return date.toLocaleDateString();
  };

  const formatWizardList = (items) => {
    if (!items || items.length === 0) return "—";
    return items.join(", ");
  };

  const formatDateInputValue = (value) => {
    if (!value) return "";
    const year = value.getFullYear();
    const month = `${value.getMonth() + 1}`.padStart(2, "0");
    const day = `${value.getDate()}`.padStart(2, "0");
    return `${year}-${month}-${day}`;
  };

  const getAssignedEmployeeName = (borrower) => {
    if (borrower.assigned_support_id) {
      return (
        borrower.assigned_support_name ||
        borrower.assigned_employee_name ||
        borrower.support_employee_name ||
        `#${borrower.assigned_support_id}`
      );
    }

    return "Unassigned";
  };

  const getAssignedByName = (borrower) =>
    borrower.assigned_by_employee_name || "-";

  const employeeId = Cookies.get("support_employee_id");
  const applyDateShortcut = (shortcut) => {
    const today = new Date();
    today.setHours(0, 0, 0, 0);
    let start = null;
    let end = null;

    if (shortcut === "today") {
      start = new Date(today);
      end = new Date(today);
    } else if (shortcut === "yesterday") {
      start = new Date(today);
      start.setDate(start.getDate() - 1);
      end = new Date(start);
    } else if (shortcut === "this_week") {
      const dayOfWeek = today.getDay();
      const diffToMonday = (dayOfWeek + 6) % 7;
      start = new Date(today);
      start.setDate(start.getDate() - diffToMonday);
      end = new Date(start);
      end.setDate(end.getDate() + 6);
    } else if (shortcut === "last_week") {
      const dayOfWeek = today.getDay();
      const diffToMonday = (dayOfWeek + 6) % 7;
      start = new Date(today);
      start.setDate(start.getDate() - diffToMonday - 7);
      end = new Date(start);
      end.setDate(end.getDate() + 6);
    } else if (shortcut === "this_month") {
      start = new Date(today.getFullYear(), today.getMonth(), 1);
      end = new Date(today.getFullYear(), today.getMonth() + 1, 0);
    } else if (shortcut === "this_year") {
      start = new Date(today.getFullYear(), 0, 1);
      end = new Date(today.getFullYear(), 11, 31);
    }

    setDateRange({
      start: start ? formatDateInputValue(start) : "",
      end: end ? formatDateInputValue(end) : "",
    });
  };
  const shouldHighlightAssignment = useCallback(
    (borrower) =>
      borrower.assignment_needs_response &&
      borrower.assigned_support_id === parseFloat(employeeId),
    [employeeId],
  );

  const filteredBorrowers = useMemo(() => {
    const term = normalizeSearchText(searchTerm);
    const termTokens = term.split(" ").filter(Boolean);
    const termDigits = normalizePhoneNumber(term);

    const normalizeDateBoundary = (value, boundary) => {
      if (!value) return null;
      const date = new Date(value);
      if (Number.isNaN(date.getTime())) return null;
      if (boundary === "start") {
        date.setHours(0, 0, 0, 0);
      } else {
        date.setHours(23, 59, 59, 999);
      }
      return date;
    };

    const startDate = normalizeDateBoundary(dateRange.start, "start");
    const endDate = normalizeDateBoundary(dateRange.end, "end");

    const matchesSearch = (borrower) => {
      if (!term) return true;
      const searchableText = normalizeSearchText(
        getBorrowerSearchValues(borrower).join(" "),
      );
      const searchableDigits = normalizePhoneNumber(
        [borrower.mobile_no, borrower.active_mobile_no, borrower.contact_phone]
          .filter(Boolean)
          .join(" "),
      );

      return (
        searchableText.includes(term) ||
        termTokens.every((token) => searchableText.includes(token)) ||
        (termDigits && searchableDigits.includes(termDigits))
      );
    };

    const matchesAssignment = (borrower) => {
      if (assignmentFilter === "unassigned") {
        return !borrower.assigned_support_id;
      }
      if (assignmentFilter === "assigned") {
        return !!borrower.assigned_support_id;
      }
      if (assignmentFilter === "me") {
        return (
          borrower.assigned_support_id === parseFloat(employeeId) &&
          borrower.assigned_by_employee_id === parseFloat(employeeId)
        );
      }
      if (assignmentFilter === "assigned_by_others") {
        return (
          borrower.assigned_support_id === parseFloat(employeeId) &&
          borrower.assigned_by_employee_id &&
          borrower.assigned_by_employee_id !== parseFloat(employeeId)
        );
      }
      return true;
    };

    const matchesCbs = (borrower) => {
      if (cbsFilter === "with") return !!borrower.has_cbs_report;
      if (cbsFilter === "without") return !borrower.has_cbs_report;
      return true;
    };

    const matchesCbsIntent = (borrower) => {
      if (cbsIntentFilter === "positive") {
        return !!borrower.cbs_positive_intent;
      }
      return true;
    };

    const matchesCompany = (borrower) => {
      if (companyFilter === "with") return !!borrower.company_name;
      if (companyFilter === "without") return !borrower.company_name;
      return true;
    };

    const matchesPhone = (borrower) => {
      if (phoneFilter === "with")
        return !!normalizePhoneNumber(borrower.mobile_no);
      if (phoneFilter === "without")
        return !normalizePhoneNumber(borrower.mobile_no);
      return true;
    };

    const matchesEmployee = (borrower) => {
      if (!employeeFilter) return true;
      const target = employeeFilter.trim().toLowerCase();
      if (!target) return true;
      const assignedName = getAssignedEmployeeName(borrower).toLowerCase();
      return assignedName.includes(target);
    };

    const matchesStatus = (borrower) => {
      if (statusFilter === "all") return true;
      return borrower.support_status === statusFilter;
    };

    const matchesDateRange = (borrower) => {
      if (!startDate && !endDate) return true;
      if (!borrower.registered_at) return false;
      const registeredDate = new Date(borrower.registered_at);
      if (Number.isNaN(registeredDate.getTime())) return false;
      if (startDate && registeredDate < startDate) return false;
      if (endDate && registeredDate > endDate) return false;
      return true;
    };

    return [...borrowers]
      .filter((borrower) =>
        [
          matchesSearch(borrower),
          matchesAssignment(borrower),
          matchesCbs(borrower),
          matchesCbsIntent(borrower),
          matchesCompany(borrower),
          matchesPhone(borrower),
          matchesStatus(borrower),
          matchesEmployee(borrower),
          matchesDateRange(borrower),
        ].every(Boolean),
      )
      .sort((a, b) => {
        if (!!a.support_is_favourite !== !!b.support_is_favourite) {
          return a.support_is_favourite ? -1 : 1;
        }
        const dateA = a.registered_at ? new Date(a.registered_at).getTime() : 0;
        const dateB = b.registered_at ? new Date(b.registered_at).getTime() : 0;
        return dateB - dateA;
      });
  }, [
    assignmentFilter,
    borrowers,
    cbsFilter,
    cbsIntentFilter,
    companyFilter,
    dateRange,
    employeeFilter,
    employeeId,
    getBorrowerSearchValues,
    normalizePhoneNumber,
    normalizeSearchText,
    phoneFilter,
    searchTerm,
    statusFilter,
  ]);

  const assignmentSummary = useMemo(() => {
    const summary = new Map();
    let total = 0;
    let unassignedCount = 0;

    filteredBorrowers.forEach((borrower) => {
      if (!borrower.assigned_support_id) {
        unassignedCount += 1;
        return;
      }
      const name = getAssignedEmployeeName(borrower);
      summary.set(name, (summary.get(name) || 0) + 1);
      total += 1;
    });

    const entries = Array.from(summary.entries())
      .map(([name, count]) => ({ name, count }))
      .sort((a, b) => b.count - a.count || a.name.localeCompare(b.name));

    if (unassignedCount > 0) {
      entries.push({ name: "Unassigned", count: unassignedCount });
    }

    return { total, entries };
  }, [filteredBorrowers]);

  const renderPropertyCampaignLeadsView = () => (
    <div
      style={{
        background: "white",
        borderRadius: "16px",
        boxShadow: "0 12px 30px rgba(0,0,0,0.05)",
        overflow: "hidden",
      }}
    >
      <div
        style={{
          padding: "18px",
          borderBottom: "1px solid #edf2fa",
          display: "flex",
          justifyContent: "space-between",
          alignItems: "center",
          gap: "12px",
          flexWrap: "wrap",
        }}
      >
        <div>
          <h2 style={{ margin: 0, color: "#0e5aa5", fontSize: "20px" }}>
            Property backed campaign leads
          </h2>
          <div style={{ color: "#6b7b93", fontSize: "13px", marginTop: "4px" }}>
            Verified OTP submissions from the property campaign landing page.
          </div>
        </div>
        <div style={{ display: "flex", gap: "8px", alignItems: "center" }}>
          <input
            type="search"
            value={propertyCampaignLeadSearch}
            onChange={(event) =>
              setPropertyCampaignLeadSearch(event.target.value)
            }
            placeholder="Search phone, postal, product"
            style={{
              minWidth: "240px",
              border: "1px solid #d9d9d9",
              borderRadius: "10px",
              padding: "9px 11px",
              fontFamily: "inherit",
            }}
          />
          <button
            type="button"
            onClick={() =>
              fetchPropertyCampaignLeads(propertyCampaignLeadSearch)
            }
            disabled={isPropertyCampaignLeadsLoading}
            style={{
              padding: "9px 13px",
              borderRadius: "10px",
              border: "1px solid #0e5aa5",
              background: isPropertyCampaignLeadsLoading ? "#f5f7fb" : "white",
              color: "#0e5aa5",
              cursor: isPropertyCampaignLeadsLoading
                ? "not-allowed"
                : "pointer",
              fontWeight: 700,
            }}
          >
            {isPropertyCampaignLeadsLoading ? "Loading..." : "Refresh"}
          </button>
        </div>
      </div>

      {propertyCampaignLeadError ? (
        <div
          style={{
            margin: "14px 18px",
            background: "#fff1f0",
            border: "1px solid #ffa39e",
            color: "#cf1322",
            padding: "10px 12px",
            borderRadius: "8px",
          }}
        >
          {propertyCampaignLeadError}
        </div>
      ) : null}

      <div style={{ overflowX: "auto" }}>
        <div style={{ minWidth: "1320px" }}>
          <div
            style={{
              display: "grid",
              gridTemplateColumns:
                "0.9fr 1fr 1.5fr 1fr 1fr 1fr 1fr 1fr 0.9fr 1fr 1fr",
              gap: "12px",
              padding: "14px 18px",
              background: "#f0f5ff",
              color: "#0e5aa5",
              fontWeight: 800,
              fontSize: "12px",
            }}
          >
            <div>Verified</div>
            <div>Phone</div>
            <div>Property</div>
            <div>Type</div>
            <div>Valuation</div>
            <div>Outstanding</div>
            <div>CPF Usage</div>
            <div>Eligible Cash</div>
            <div>Facility</div>
            <div>Monthly P+I</div>
            <div>Interest Only</div>
          </div>

          {isPropertyCampaignLeadsLoading ? (
            <div style={{ padding: "24px", textAlign: "center" }}>
              Loading property campaign leads...
            </div>
          ) : propertyCampaignLeads.length === 0 ? (
            <div
              style={{
                padding: "24px",
                textAlign: "center",
                color: "#6b7b93",
              }}
            >
              No verified property campaign leads found.
            </div>
          ) : (
            propertyCampaignLeads.map((lead) => {
              const phoneNumber = normalizePhoneNumber(lead.phone_number);
              const fullUnit =
                lead.matched_address_unit ||
                [lead.address_floor, lead.address_unit]
                  .filter(Boolean)
                  .join("-");
              const productLabel =
                lead.product === "firstlm"
                  ? "1st Legal Mortgage"
                  : "Caveat Backed Loan";

              return (
                <div
                  key={lead.id}
                  style={{
                    display: "grid",
                    gridTemplateColumns:
                      "0.9fr 1fr 1.5fr 1fr 1fr 1fr 1fr 1fr 0.9fr 1fr 1fr",
                    gap: "12px",
                    padding: "14px 18px",
                    alignItems: "center",
                    borderTop: "1px solid #f0f0f0",
                    fontSize: "12px",
                  }}
                >
                  <div>
                    <div style={{ fontWeight: 700 }}>
                      {formatDate(lead.submitted_at)}
                    </div>
                    <div style={{ color: "#6b7b93" }}>
                      {lead.lead_submitted ? "Callback requested" : "Unlocked"}
                    </div>
                  </div>
                  <div className="support-phone-row">
                    <span>{lead.phone_number || "-"}</span>
                    {phoneNumber ? (
                      <span className="support-phone-actions">
                        <a
                          className="support-phone-action"
                          href={`tel:+${phoneNumber}`}
                          title="Call lead"
                          aria-label="Call property campaign lead"
                        >
                          <FontAwesomeIcon icon={faPhone} />
                        </a>
                        <a
                          className="support-phone-action support-phone-action--whatsapp"
                          href={`https://wa.me/${phoneNumber}?text=${encodeURIComponent(
                            "Hi, this is SmartLend following up on your property backed loan estimate.",
                          )}`}
                          target="_blank"
                          rel="noreferrer"
                          title="WhatsApp lead"
                          aria-label="WhatsApp property campaign lead"
                        >
                          <FontAwesomeIcon icon={faWhatsapp} />
                        </a>
                      </span>
                    ) : null}
                  </div>
                  <div>
                    <div style={{ fontWeight: 700 }}>
                      {lead.postal_code || "-"}
                      {fullUnit ? `, #${fullUnit}` : ""}
                    </div>
                    <div style={{ color: "#6b7b93" }}>
                      {lead.matched_address || "-"}
                    </div>
                    <div style={{ color: "#6b7b93" }}>
                      {lead.district ? `D${lead.district}` : "-"}
                      {lead.region
                        ? ` / ${String(lead.region).toUpperCase()}`
                        : ""}
                    </div>
                  </div>
                  <div style={{ textTransform: "capitalize" }}>
                    {lead.property_type || lead.selected_property_type || "-"}
                  </div>
                  <div>{formatCurrency(lead.valuation)}</div>
                  <div>{formatCurrency(lead.mortgage_amount)}</div>
                  <div>{formatCurrency(lead.cpf_usage)}</div>
                  <div style={{ fontWeight: 800, color: "#0e5aa5" }}>
                    {formatCurrency(lead.net_cash_released)}
                  </div>
                  <div>
                    <div>{productLabel}</div>
                    <div style={{ color: "#6b7b93" }}>
                      {lead.tenor || "-"} {lead.tenor_unit || ""}
                    </div>
                  </div>
                  <div>{formatCurrency(lead.monthly_pi)}</div>
                  <div>{formatCurrency(lead.monthly_interest_only)}</div>
                </div>
              );
            })
          )}
        </div>
      </div>
    </div>
  );

  const assigneeOptions = assignees.filter(
    (assignee) => assignee.id !== parseFloat(employeeId),
  );

  return (
    <div
      style={{
        padding: "32px",
        background: "#f5f7fb",
        minHeight: "100vh",
        fontFamily: "Manrope, sans-serif",
      }}
    >
      <style>{`
        @keyframes supportSlCreatedBlink {
          0%, 100% {
            background-color: #fff1f0;
            box-shadow: inset 4px 0 0 #cf1322;
          }
          50% {
            background-color: #ffd6d6;
            box-shadow: inset 4px 0 0 #ff4d4f;
          }
        }

        .support-sl-created-highlight {
          animation: supportSlCreatedBlink 1.2s ease-in-out infinite;
        }

        @keyframes supportCbsPositiveIntentPulse {
          0%, 100% {
            background-color: #f6ffed;
            box-shadow: inset 4px 0 0 #389e0d;
          }
          50% {
            background-color: #d9f7be;
            box-shadow: inset 4px 0 0 #52c41a;
          }
        }

        .support-cbs-positive-intent-highlight,
        .support-cbs-positive-intent-highlight.support-sl-created-highlight {
          animation: supportCbsPositiveIntentPulse 1.2s ease-in-out infinite;
        }

        .support-cbs-intent-badge {
          align-self: flex-start;
          display: inline-flex;
          align-items: center;
          padding: 3px 8px;
          border-radius: 999px;
          background: #e8f8df;
          color: #237804;
          border: 1px solid #b7eb8f;
          font-size: 11px;
          font-weight: 800;
          line-height: 1.3;
        }
      `}</style>
      <div style={{ marginBottom: "16px", display: "grid", gap: "8px" }}>
        <div
          style={{
            display: "flex",
            alignItems: "center",
            justifyContent: "space-between",
            gap: "12px",
            flexWrap: "wrap",
          }}
        >
          <div
            style={{
              display: "flex",
              alignItems: "center",
              gap: "10px",
              flexWrap: "wrap",
            }}
          >
            <h1 style={{ margin: 0, color: "#0e5aa5", fontWeight: 800 }}>
              Customer Support Dashboard
            </h1>
            {isAdmin ? (
              <span
                style={{
                  display: "inline-flex",
                  alignItems: "center",
                  gap: "6px",
                  padding: "4px 10px",
                  borderRadius: "999px",
                  background: "#fff7e6",
                  color: "#ad4e00",
                  fontWeight: 700,
                  fontSize: "12px",
                }}
              >
                Admin access enabled
              </span>
            ) : null}
          </div>
          <div style={{ display: "flex", gap: "8px", alignItems: "center" }}>
            {isAdmin && !isLoanRequestOnlySupportUser ? (
              <button
                type="button"
                onClick={downloadBorrowerEmailsCsv}
                disabled={isDownloadingBorrowerEmails}
                style={{
                  padding: "8px 14px",
                  borderRadius: "10px",
                  border: "1px solid #0e5aa5",
                  background: isDownloadingBorrowerEmails ? "#f5f7fb" : "white",
                  color: isDownloadingBorrowerEmails ? "#6b7b93" : "#0e5aa5",
                  cursor: isDownloadingBorrowerEmails
                    ? "not-allowed"
                    : "pointer",
                  fontWeight: 700,
                }}
              >
                {isDownloadingBorrowerEmails
                  ? "Downloading..."
                  : "Download Borrower Emails"}
              </button>
            ) : null}
            <div
              style={{
                display: "inline-flex",
                border: "1px solid #0e5aa5",
                borderRadius: "10px",
                overflow: "hidden",
                flexWrap: "wrap",
                background: "white",
              }}
            >
              {(isLoanRequestOnlySupportUser
                ? [{ key: "loan-requests", label: "Loan Requests" }]
                : [
                    { key: "dashboard", label: "Dashboard" },
                    { key: "property-applications", label: "Property Applications" },
                    { key: "property-application-drafts", label: "Property application follow-up" },
                    { key: "cases", label: "Case View" },
                    { key: "loan-requests", label: "Loan Requests" },
                    {
                      key: "property-campaign-leads",
                      label: "Property backed campaign leads",
                    },
                  ]
              ).map((tab, index, tabs) => (
                <button
                  key={tab.key}
                  type="button"
                  onClick={() => {
                    setActiveView(tab.key);
                    if (tab.key === "cases") {
                      loadCaseBoard();
                    }
                    if (tab.key === "property-campaign-leads") {
                      fetchPropertyCampaignLeads(propertyCampaignLeadSearch);
                    }
                  }}
                  style={{
                    padding: "8px 14px",
                    border: "none",
                    borderRight:
                      index === tabs.length - 1 ? "none" : "1px solid #0e5aa5",
                    background: activeView === tab.key ? "#0e5aa5" : "white",
                    color: activeView === tab.key ? "white" : "#0e5aa5",
                    cursor: "pointer",
                    fontWeight: 700,
                  }}
                >
                  {tab.label}
                </button>
              ))}
            </div>
            <button
              type="button"
              onClick={handleLogout}
              style={{
                padding: "8px 14px",
                borderRadius: "10px",
                border: "1px solid #0e5aa5",
                background: "white",
                color: "#0e5aa5",
                cursor: "pointer",
                fontWeight: 700,
              }}
            >
              Logout
            </button>
          </div>
        </div>
        <p style={{ color: "#6b7b93", marginTop: 0 }}>
          Review borrower signups, see BTI ratings, and open the detailed view
          shared with the admin database.
        </p>
      </div>

      {error ? (
        <div
          style={{
            background: "#fff1f0",
            border: "1px solid #ffa39e",
            color: "#cf1322",
            padding: "12px 16px",
            borderRadius: "8px",
            marginBottom: "12px",
          }}
        >
          {error}
        </div>
      ) : null}

      {activeView === "property-applications" ? (
        <PropertyApplications onOpenBorrower={(borrower) => {
          setSelectedBorrower(borrower);
          fetchBorrowerProfile(borrower);
        }} />
      ) : activeView === "property-application-drafts" ? (
        <PropertyApplicationDrafts onOpenBorrower={(borrower) => {
          setSelectedBorrower(borrower);
          fetchBorrowerProfile(borrower);
        }} />
      ) : activeView === "loan-requests" ? (
        <div
          style={{
            background: "white",
            borderRadius: "16px",
            boxShadow: "0 12px 30px rgba(0,0,0,0.05)",
            padding: "18px",
          }}
        >
          <LoanRequestGrid
            mode="support"
            showLenderActions={false}
            onOpenBorrowerProfile={(borrower) => {
              setSelectedBorrower(borrower);
              fetchBorrowerProfile(borrower);
            }}
          />
        </div>
      ) : activeView === "cases" ? (
        <div
          style={{
            background: "white",
            borderRadius: "16px",
            boxShadow: "0 12px 30px rgba(0,0,0,0.05)",
            padding: "18px",
          }}
        >
          {isCaseBoardLoading ? (
            <div>Loading case view...</div>
          ) : caseBoardStatuses.length === 0 ? (
            <div style={{ color: "#6b7b93" }}>No cases found.</div>
          ) : (
            <div style={{ display: "grid", gap: "10px" }}>
              {caseBoardStatuses.map((statusGroup) => {
                const statusOpen = !!expandedStatuses[statusGroup.status];
                return (
                  <div
                    key={statusGroup.status}
                    style={{
                      border: "1px solid #e6ebf5",
                      borderRadius: "12px",
                      overflow: "hidden",
                    }}
                  >
                    <button
                      type="button"
                      onClick={() =>
                        setExpandedStatuses((prev) => ({
                          ...prev,
                          [statusGroup.status]: !prev[statusGroup.status],
                        }))
                      }
                      style={{
                        width: "100%",
                        textAlign: "left",
                        padding: "12px 14px",
                        border: "none",
                        background: "#f0f5ff",
                        color: "#0e5aa5",
                        fontWeight: 800,
                        cursor: "pointer",
                      }}
                    >
                      {statusGroup.status} ({statusGroup.count})
                    </button>

                    {statusOpen ? (
                      <div
                        style={{ padding: "10px", display: "grid", gap: "8px" }}
                      >
                        {statusGroup.cases.map((item) => {
                          const caseOpen = !!expandedCases[item.id];
                          const caseViewRemarkValue =
                            caseViewRemarkDrafts[item.id] || "";
                          const caseViewDocumentRemark =
                            caseViewDocumentRemarks[item.id] || "";
                          const caseViewDocumentFile =
                            caseViewDocumentFiles[item.id] || null;
                          return (
                            <div
                              key={item.id}
                              style={{
                                border: item.is_loan_tagged
                                  ? "1px solid #9254de"
                                  : "1px solid #edf2fa",
                                borderRadius: "10px",
                                width: "100%",
                                background: item.is_loan_tagged
                                  ? "#f9f0ff"
                                  : "#f0f5ff",
                              }}
                            >
                              <button
                                type="button"
                                onClick={() =>
                                  setExpandedCases((prev) => ({
                                    ...prev,
                                    [item.id]: !prev[item.id],
                                  }))
                                }
                                style={{
                                  width: "100%",
                                  textAlign: "left",
                                  padding: "10px 12px",
                                  border: "none",
                                  background: "white",
                                  cursor: "pointer",
                                  background: "#d8e5ffff",
                                  borderRadius: "10px 10px 0px 0px",
                                }}
                              >
                                <span
                                  onClick={(event) => {
                                    event.stopPropagation();
                                    openBorrowerDetailsFromCaseView(item);
                                  }}
                                  role="button"
                                  tabIndex={0}
                                  onKeyDown={(event) => {
                                    if (
                                      event.key === "Enter" ||
                                      event.key === " "
                                    ) {
                                      event.preventDefault();
                                      event.stopPropagation();
                                      openBorrowerDetailsFromCaseView(item);
                                    }
                                  }}
                                  style={{
                                    fontWeight: 700,
                                    color: "#0e5aa5",
                                    cursor: "pointer",
                                    textDecoration: "underline",
                                  }}
                                >
                                  {item.company_name || item.borrower_id}
                                </span>
                                <div
                                  style={{ color: "#6b7b93", fontSize: "12px" }}
                                >
                                  {item.product_label}
                                </div>
                                {item.is_loan_tagged ? (
                                  <div
                                    style={{
                                      color: "#722ed1",
                                      fontSize: "12px",
                                      fontWeight: 700,
                                    }}
                                  >
                                    Tagged: {item.tagged_loan_type_label} #
                                    {item.tagged_loan_request_id} (
                                    {formatCurrency(item.tagged_loan_amount)})
                                  </div>
                                ) : null}
                              </button>

                              <div
                                style={{
                                  borderTop: "1px solid #edf2fa",
                                  padding: "8px 12px",
                                  display: "flex",
                                  justifyContent: "space-between",
                                  alignItems: "center",
                                  gap: "10px",
                                  flexWrap: "wrap",
                                }}
                              >
                                <div
                                  style={{ fontSize: "12px", color: "#6b7b93" }}
                                >
                                  Client Status
                                </div>
                                <select
                                  value={item.status_group || ""}
                                  onChange={(event) =>
                                    updateCaseViewStatus(
                                      item,
                                      event.target.value,
                                      event.target.value === "Following Up"
                                        ? item.support_follow_up_date || ""
                                        : null,
                                    )
                                  }
                                  disabled={
                                    caseViewUpdatingStatusCaseId === item.id
                                  }
                                  style={{
                                    minWidth: "220px",
                                    padding: "6px 8px",
                                    borderRadius: "8px",
                                    border: "1px solid #d9d9d9",
                                    fontFamily: "inherit",
                                    background: "white",
                                  }}
                                >
                                  <option value="" disabled>
                                    Set status
                                  </option>
                                  {supportStatuses.map((status) => (
                                    <option key={status} value={status}>
                                      {status}
                                    </option>
                                  ))}
                                </select>
                                {item.status_group === "Following Up" ? (
                                  <input
                                    type="date"
                                    value={item.support_follow_up_date || ""}
                                    onChange={(event) =>
                                      updateCaseViewStatus(
                                        item,
                                        "Following Up",
                                        event.target.value,
                                      )
                                    }
                                    disabled={
                                      caseViewUpdatingStatusCaseId === item.id
                                    }
                                    title="Follow-up date"
                                    style={{
                                      minWidth: "170px",
                                      padding: "6px 8px",
                                      borderRadius: "8px",
                                      border: "1px solid #d9d9d9",
                                      fontFamily: "inherit",
                                      background: "white",
                                    }}
                                  />
                                ) : null}
                              </div>

                              {caseOpen ? (
                                <div
                                  style={{
                                    borderTop: "1px solid #edf2fa",
                                    padding: "10px",
                                    width: "100%",
                                  }}
                                >
                                  <div
                                    style={{
                                      display: "flex",
                                      gap: "40px",
                                      overflowX: "scroll",
                                      paddingBottom: "6px",
                                      width: "calc(100vw - 160px)",
                                    }}
                                  >
                                    {(item.timeline || []).map(
                                      (timelineItem) => (
                                        <div
                                          key={timelineItem.id}
                                          style={{
                                            minWidth: "260px",
                                            background: "#fafcff",
                                            border: "1px solid #e6ebf5",
                                            borderRadius: "10px",
                                            padding: "10px",
                                          }}
                                        >
                                          <div
                                            style={{
                                              fontWeight: 700,
                                              textTransform: "capitalize",
                                            }}
                                          >
                                            {timelineItem.activity_type}
                                          </div>
                                          <div
                                            style={{
                                              color: "#6b7b93",
                                              fontSize: "12px",
                                            }}
                                          >
                                            {timelineItem.author_name ||
                                              "System"}{" "}
                                            •{" "}
                                            {timelineItem.created_at_formatted ||
                                              ""}
                                          </div>
                                          {timelineItem.remark ? (
                                            <div style={{ marginTop: "6px" }}>
                                              {timelineItem.remark}
                                            </div>
                                          ) : null}
                                          {timelineItem.document_url ? (
                                            <a
                                              href={timelineItem.document_url}
                                              target="_blank"
                                              rel="noreferrer"
                                              style={{
                                                marginTop: "6px",
                                                display: "inline-block",
                                                color: "#0e5aa5",
                                              }}
                                            >
                                              {timelineItem.document_name ||
                                                "View document"}
                                            </a>
                                          ) : null}
                                        </div>
                                      ),
                                    )}
                                    {(item.timeline || []).length === 0 ? (
                                      <div
                                        style={{
                                          color: "#6b7b93",
                                          fontSize: "12px",
                                        }}
                                      >
                                        No timeline items yet.
                                      </div>
                                    ) : null}
                                  </div>

                                  <div
                                    style={{
                                      marginTop: "10px",
                                      display: "grid",
                                      gap: "8px",
                                    }}
                                  >
                                    <textarea
                                      value={caseViewRemarkValue}
                                      onChange={(e) =>
                                        setCaseViewRemarkDrafts((prev) => ({
                                          ...prev,
                                          [item.id]: e.target.value,
                                        }))
                                      }
                                      placeholder="Add case remark"
                                      style={{
                                        minHeight: "70px",
                                        borderRadius: "10px",
                                        border: "1px solid #d9d9d9",
                                        padding: "10px",
                                      }}
                                    />
                                    <button
                                      type="button"
                                      onClick={() =>
                                        addCaseRemarkToCase(
                                          item.id,
                                          caseViewRemarkValue,
                                          { fromCaseView: true },
                                        )
                                      }
                                      disabled={
                                        caseViewSavingRemarkCaseId ===
                                          item.id || !caseViewRemarkValue.trim()
                                      }
                                      style={{
                                        alignSelf: "flex-end",
                                        padding: "8px 12px",
                                        borderRadius: "8px",
                                        border: "none",
                                        background: "#0e5aa5",
                                        color: "white",
                                        fontWeight: 700,
                                      }}
                                    >
                                      {caseViewSavingRemarkCaseId === item.id
                                        ? "Saving..."
                                        : "Add remark"}
                                    </button>

                                    <input
                                      type="file"
                                      onChange={(e) =>
                                        setCaseViewDocumentFiles((prev) => ({
                                          ...prev,
                                          [item.id]:
                                            e.target.files?.[0] || null,
                                        }))
                                      }
                                    />
                                    <input
                                      type="text"
                                      value={caseViewDocumentRemark}
                                      onChange={(e) =>
                                        setCaseViewDocumentRemarks((prev) => ({
                                          ...prev,
                                          [item.id]: e.target.value,
                                        }))
                                      }
                                      placeholder="Document remark (optional)"
                                      style={{
                                        borderRadius: "10px",
                                        border: "1px solid #d9d9d9",
                                        padding: "10px",
                                      }}
                                    />
                                    <button
                                      type="button"
                                      onClick={() =>
                                        uploadDocumentToCase(
                                          item.id,
                                          caseViewDocumentFile,
                                          caseViewDocumentRemark,
                                          { fromCaseView: true },
                                        )
                                      }
                                      disabled={
                                        !caseViewDocumentFile ||
                                        caseViewUploadingDocCaseId === item.id
                                      }
                                      style={{
                                        alignSelf: "flex-end",
                                        padding: "8px 12px",
                                        borderRadius: "8px",
                                        border: "none",
                                        background: "#1d6f42",
                                        color: "white",
                                        fontWeight: 700,
                                      }}
                                    >
                                      {caseViewUploadingDocCaseId === item.id
                                        ? "Uploading..."
                                        : "Upload document"}
                                    </button>

                                    <button
                                      type="button"
                                      onClick={() =>
                                        openTagLoanModal(
                                          item.id,
                                          item.borrower_id,
                                        )
                                      }
                                      style={{
                                        alignSelf: "flex-end",
                                        padding: "8px 12px",
                                        borderRadius: "8px",
                                        border: "none",
                                        background: "#722ed1",
                                        color: "white",
                                        fontWeight: 700,
                                      }}
                                    >
                                      {taggingLoanCaseId === item.id
                                        ? "Tagging..."
                                        : "Tag Loans"}
                                    </button>

                                    <button
                                      type="button"
                                      onClick={() =>
                                        deleteSupportCaseById(item.id, {
                                          fromCaseView: true,
                                        })
                                      }
                                      disabled={deletingCaseId === item.id}
                                      style={{
                                        alignSelf: "flex-end",
                                        padding: "8px 12px",
                                        borderRadius: "8px",
                                        border: "1px solid #ff7875",
                                        background: "#fff1f0",
                                        color: "#cf1322",
                                        fontWeight: 700,
                                      }}
                                    >
                                      {deletingCaseId === item.id
                                        ? "Deleting..."
                                        : "Delete case"}
                                    </button>
                                  </div>
                                </div>
                              ) : null}
                            </div>
                          );
                        })}
                      </div>
                    ) : null}
                  </div>
                );
              })}
            </div>
          )}
        </div>
      ) : activeView === "property-campaign-leads" ? (
        renderPropertyCampaignLeadsView()
      ) : (
        <>
          <div
            style={{
              display: "flex",
              justifyContent: "flex-end",
              marginBottom: "12px",
            }}
          >
            <button
              type="button"
              onClick={openClientAccountModal}
              style={{
                padding: "10px 16px",
                borderRadius: "10px",
                border: "none",
                background: "#0e5aa5",
                color: "white",
                cursor: "pointer",
                fontWeight: 800,
              }}
            >
              Create Client Account
            </button>
          </div>

          <Modal
            open={isClientAccountModalOpen}
            onCancel={() => {
              if (!isCreatingClientAccount) {
                setIsClientAccountModalOpen(false);
              }
            }}
            footer={null}
            width={760}
            destroyOnClose={false}
          >
            <form
              onSubmit={createClientAccount}
              style={{
                background: "transparent",
                borderRadius: 0,
                boxShadow: "none",
                padding: "8px 0 0",
                marginBottom: 0,
                display: "grid",
                gap: "14px",
              }}
            >
              <div
                style={{
                  display: "flex",
                  justifyContent: "space-between",
                  alignItems: "flex-start",
                  gap: "12px",
                  flexWrap: "wrap",
                }}
              >
                <div>
                  <h2
                    style={{
                      margin: "0 0 4px",
                      color: "#0e5aa5",
                      fontSize: "18px",
                      fontWeight: 800,
                    }}
                  >
                    Create Client Account
                  </h2>
                  <p style={{ margin: 0, color: "#6b7b93", fontSize: "13px" }}>
                    Creates an active borrower account without OTP or email
                    confirmation.
                  </p>
                </div>
                <button
                  type="submit"
                  disabled={isCreatingClientAccount}
                  style={{
                    padding: "10px 16px",
                    borderRadius: "10px",
                    border: "none",
                    background: isCreatingClientAccount ? "#8bb6dd" : "#0e5aa5",
                    color: "white",
                    cursor: isCreatingClientAccount ? "not-allowed" : "pointer",
                    fontWeight: 800,
                  }}
                >
                  {isCreatingClientAccount ? "Creating..." : "Create Account"}
                </button>
              </div>

              <div
                style={{
                  display: "grid",
                  gridTemplateColumns: "1fr",
                  gap: "14px",
                }}
              >
                <label
                  style={{ display: "grid", gap: "6px", color: "#25324b" }}
                >
                  <span style={{ fontSize: "12px", fontWeight: 800 }}>
                    Client name
                  </span>
                  <input
                    type="text"
                    value={clientAccountForm.client_name}
                    onChange={(event) =>
                      updateClientAccountForm("client_name", event.target.value)
                    }
                    placeholder="test user"
                    style={{
                      width: "100%",
                      padding: "12px 14px",
                      borderRadius: "10px",
                      border: "1px solid #d9d9d9",
                      fontFamily: "inherit",
                      boxSizing: "border-box",
                    }}
                  />
                </label>
                <label
                  style={{ display: "grid", gap: "6px", color: "#25324b" }}
                >
                  <span style={{ fontSize: "12px", fontWeight: 800 }}>
                    Email address
                  </span>
                  <input
                    type="email"
                    value={clientAccountForm.email}
                    onChange={(event) =>
                      updateClientAccountForm("email", event.target.value)
                    }
                    placeholder="test@gmail.com"
                    style={{
                      width: "100%",
                      padding: "12px 14px",
                      borderRadius: "10px",
                      border: "1px solid #d9d9d9",
                      fontFamily: "inherit",
                      boxSizing: "border-box",
                    }}
                  />
                </label>
                <label
                  style={{ display: "grid", gap: "6px", color: "#25324b" }}
                >
                  <span style={{ fontSize: "12px", fontWeight: 800 }}>
                    Phone number
                  </span>
                  <input
                    type="text"
                    value={clientAccountForm.mobile_no}
                    onChange={(event) =>
                      updateClientAccountForm("mobile_no", event.target.value)
                    }
                    placeholder="65012345678"
                    inputMode="numeric"
                    style={{
                      width: "100%",
                      padding: "12px 14px",
                      borderRadius: "10px",
                      border: "1px solid #d9d9d9",
                      fontFamily: "inherit",
                      boxSizing: "border-box",
                    }}
                  />
                </label>
              </div>

              {createdClientAccount ? (
                <div
                  style={{
                    display: "flex",
                    justifyContent: "space-between",
                    alignItems: "center",
                    gap: "12px",
                    flexWrap: "wrap",
                    padding: "12px",
                    borderRadius: "12px",
                    border: "1px solid #b7eb8f",
                    background: "#f6ffed",
                    color: "#237804",
                  }}
                >
                  <div style={{ display: "grid", gap: "3px" }}>
                    <strong>
                      Created {createdClientAccount.principal_name} (
                      {createdClientAccount.email})
                    </strong>
                    <span>
                      Generated password:{" "}
                      <strong>{createdClientAccount.generated_password}</strong>
                    </span>
                  </div>
                  <button
                    type="button"
                    onClick={() => {
                      navigator.clipboard?.writeText(
                        createdClientAccount.generated_password,
                      );
                      message.success("Password copied.");
                    }}
                    style={{
                      padding: "8px 12px",
                      borderRadius: "8px",
                      border: "1px solid #52c41a",
                      background: "white",
                      color: "#237804",
                      fontWeight: 800,
                      cursor: "pointer",
                    }}
                  >
                    Copy Password
                  </button>
                </div>
              ) : null}
            </form>
          </Modal>

          <div
            style={{
              display: "flex",
              flexWrap: "wrap",
              gap: "12px",
              alignItems: "center",
              marginBottom: "12px",
            }}
          >
            <input
              type="text"
              placeholder="Search name, MyInfo, Singpass, email or phone"
              value={searchTerm}
              onChange={(e) => setSearchTerm(e.target.value)}
              style={{
                flex: "1 1 220px",
                padding: "10px 12px",
                borderRadius: "10px",
                border: "1px solid #d9d9d9",
                fontFamily: "inherit",
              }}
            />
            <select
              value={assignmentFilter}
              onChange={(e) => setAssignmentFilter(e.target.value)}
              style={{
                flex: "1 1 160px",
                padding: "10px 12px",
                borderRadius: "10px",
                border: "1px solid #d9d9d9",
                fontFamily: "inherit",
              }}
            >
              <option value="all">All assignments</option>
              {isAdmin ? <option value="assigned">All assigned</option> : null}
              <option value="me">Assigned to me</option>
              <option value="assigned_by_others">Assigned by others</option>
              <option value="unassigned">Unassigned</option>
            </select>
            <select
              value={cbsFilter}
              onChange={(e) => setCbsFilter(e.target.value)}
              style={{
                flex: "1 1 160px",
                padding: "10px 12px",
                borderRadius: "10px",
                border: "1px solid #d9d9d9",
                fontFamily: "inherit",
              }}
            >
              <option value="all">All CBS statuses</option>
              <option value="with">With CBS report</option>
              <option value="without">Without CBS report</option>
            </select>
            <select
              value={cbsIntentFilter}
              onChange={(e) => setCbsIntentFilter(e.target.value)}
              style={{
                flex: "1 1 190px",
                padding: "10px 12px",
                borderRadius: "10px",
                border: "1px solid #d9d9d9",
                fontFamily: "inherit",
              }}
            >
              <option value="all">All CBS questionnaire</option>
              <option value="positive">Positive CBS responses</option>
            </select>
            <select
              value={companyFilter}
              onChange={(e) => setCompanyFilter(e.target.value)}
              style={{
                flex: "1 1 160px",
                padding: "10px 12px",
                borderRadius: "10px",
                border: "1px solid #d9d9d9",
                fontFamily: "inherit",
              }}
            >
              <option value="all">All company names</option>
              <option value="with">With company name</option>
              <option value="without">Without company name</option>
            </select>
            <select
              value={phoneFilter}
              onChange={(e) => setPhoneFilter(e.target.value)}
              style={{
                flex: "1 1 160px",
                padding: "10px 12px",
                borderRadius: "10px",
                border: "1px solid #d9d9d9",
                fontFamily: "inherit",
              }}
            >
              <option value="all">All phone statuses</option>
              <option value="with">With phone number</option>
              <option value="without">Without phone number</option>
            </select>
            <select
              value={statusFilter}
              onChange={(e) => setStatusFilter(e.target.value)}
              style={{
                flex: "1 1 160px",
                padding: "10px 12px",
                borderRadius: "10px",
                border: "1px solid #d9d9d9",
                fontFamily: "inherit",
              }}
            >
              <option value="all">All statuses</option>
              {supportStatuses.map((status) => (
                <option key={status} value={status}>
                  {status}
                </option>
              ))}
            </select>
            {isAdmin ? (
              <input
                type="text"
                placeholder="Filter by employee name"
                value={employeeFilter}
                onChange={(e) => setEmployeeFilter(e.target.value)}
                style={{
                  flex: "1 1 160px",
                  padding: "10px 12px",
                  borderRadius: "10px",
                  border: "1px solid #d9d9d9",
                  fontFamily: "inherit",
                }}
              />
            ) : null}
            {isRefreshing ? (
              <span style={{ color: "#6b7b93", fontSize: "12px" }}>
                Refreshing data...
              </span>
            ) : null}
          </div>

          <div
            style={{
              background: "white",
              borderRadius: "12px",
              padding: "12px 16px",
              marginBottom: "16px",
              display: "grid",
              gap: "10px",
              boxShadow: "0 10px 20px rgba(0,0,0,0.04)",
            }}
          >
            <div style={{ fontWeight: 700, color: "#0e5aa5" }}>
              Filter by registered date
            </div>
            <div
              style={{
                display: "flex",
                flexWrap: "wrap",
                gap: "12px",
                alignItems: "center",
              }}
            >
              <label style={{ display: "grid", gap: "6px", color: "#6b7b93" }}>
                Start date
                <input
                  type="date"
                  value={dateRange.start}
                  onChange={(event) =>
                    setDateRange((prev) => ({
                      ...prev,
                      start: event.target.value,
                    }))
                  }
                  style={{
                    padding: "8px 10px",
                    borderRadius: "8px",
                    border: "1px solid #d9d9d9",
                    fontFamily: "inherit",
                  }}
                />
              </label>
              <label style={{ display: "grid", gap: "6px", color: "#6b7b93" }}>
                End date
                <input
                  type="date"
                  value={dateRange.end}
                  onChange={(event) =>
                    setDateRange((prev) => ({
                      ...prev,
                      end: event.target.value,
                    }))
                  }
                  style={{
                    padding: "8px 10px",
                    borderRadius: "8px",
                    border: "1px solid #d9d9d9",
                    fontFamily: "inherit",
                  }}
                />
              </label>
              <div style={{ display: "flex", flexWrap: "wrap", gap: "8px" }}>
                <button
                  type="button"
                  onClick={() => applyDateShortcut("today")}
                  style={{
                    padding: "6px 12px",
                    borderRadius: "999px",
                    border: "1px solid #0e5aa5",
                    background: "white",
                    color: "#0e5aa5",
                    cursor: "pointer",
                    fontWeight: 600,
                    fontSize: "12px",
                  }}
                >
                  Today
                </button>
                <button
                  type="button"
                  onClick={() => applyDateShortcut("yesterday")}
                  style={{
                    padding: "6px 12px",
                    borderRadius: "999px",
                    border: "1px solid #0e5aa5",
                    background: "white",
                    color: "#0e5aa5",
                    cursor: "pointer",
                    fontWeight: 600,
                    fontSize: "12px",
                  }}
                >
                  Yesterday
                </button>
                <button
                  type="button"
                  onClick={() => applyDateShortcut("this_week")}
                  style={{
                    padding: "6px 12px",
                    borderRadius: "999px",
                    border: "1px solid #0e5aa5",
                    background: "white",
                    color: "#0e5aa5",
                    cursor: "pointer",
                    fontWeight: 600,
                    fontSize: "12px",
                  }}
                >
                  This week
                </button>
                <button
                  type="button"
                  onClick={() => applyDateShortcut("last_week")}
                  style={{
                    padding: "6px 12px",
                    borderRadius: "999px",
                    border: "1px solid #0e5aa5",
                    background: "white",
                    color: "#0e5aa5",
                    cursor: "pointer",
                    fontWeight: 600,
                    fontSize: "12px",
                  }}
                >
                  Last week
                </button>
                <button
                  type="button"
                  onClick={() => applyDateShortcut("this_month")}
                  style={{
                    padding: "6px 12px",
                    borderRadius: "999px",
                    border: "1px solid #0e5aa5",
                    background: "white",
                    color: "#0e5aa5",
                    cursor: "pointer",
                    fontWeight: 600,
                    fontSize: "12px",
                  }}
                >
                  This month
                </button>
                <button
                  type="button"
                  onClick={() => applyDateShortcut("this_year")}
                  style={{
                    padding: "6px 12px",
                    borderRadius: "999px",
                    border: "1px solid #0e5aa5",
                    background: "white",
                    color: "#0e5aa5",
                    cursor: "pointer",
                    fontWeight: 600,
                    fontSize: "12px",
                  }}
                >
                  This year
                </button>
                <button
                  type="button"
                  onClick={() => setDateRange({ start: "", end: "" })}
                  style={{
                    padding: "6px 12px",
                    borderRadius: "999px",
                    border: "1px solid #d9d9d9",
                    background: "#f5f7fb",
                    color: "#6b7b93",
                    cursor: "pointer",
                    fontWeight: 600,
                    fontSize: "12px",
                  }}
                >
                  Clear
                </button>
              </div>
            </div>
          </div>

          {isAdmin ? (
            <div
              style={{
                background: "white",
                borderRadius: "16px",
                padding: "16px",
                marginBottom: "16px",
                boxShadow: "0 12px 30px rgba(0,0,0,0.05)",
              }}
            >
              <div
                style={{
                  display: "flex",
                  alignItems: "center",
                  justifyContent: "space-between",
                  flexWrap: "wrap",
                  gap: "8px",
                }}
              >
                <div style={{ fontWeight: 800, color: "#0e5aa5" }}>
                  Assigned client counts
                </div>
                <div
                  style={{
                    display: "flex",
                    flexWrap: "wrap",
                    gap: "10px",
                  }}
                >
                  {assignmentSummary.entries.length === 0 ? (
                    <span style={{ color: "#6b7b93" }}>
                      No assigned clients in this view.
                    </span>
                  ) : (
                    assignmentSummary.entries.map((entry) => (
                      <div
                        key={entry.name}
                        style={{
                          display: "inline-flex",
                          alignItems: "center",
                          gap: "8px",
                          padding: "6px 12px",
                          borderRadius: "999px",
                          border: "1px solid #e6f0ff",
                          background: "#f7faff",
                          color: "#0e5aa5",
                          fontWeight: 700,
                          fontSize: "12px",
                        }}
                      >
                        <span>{entry.name}</span>
                        <span
                          style={{
                            background: "white",
                            borderRadius: "999px",
                            padding: "2px 8px",
                            color: "#1f1f1f",
                          }}
                        >
                          {entry.count}
                        </span>
                      </div>
                    ))
                  )}
                </div>
                {/* <div style={{ fontWeight: 700, color: "#1f1f1f" }}>
              Total assigned: {assignmentSummary.total} */}
                {/* </div> */}
              </div>
            </div>
          ) : null}

          <div
            style={{
              display: "flex",
              justifyContent: "space-between",
              alignItems: "center",
              marginBottom: "8px",
              gap: "10px",
              flexWrap: "wrap",
            }}
          >
            <div style={{ color: "#6b7b93", fontSize: "12px" }}>
              Page {borrowerPage} of {totalBorrowerPages}
            </div>
            <div style={{ display: "flex", gap: "8px", alignItems: "center" }}>
              <select
                value={borrowersPerPage}
                onChange={(e) => {
                  const nextPerPage = Number(e.target.value);
                  fetchBorrowers({
                    page: 1,
                    perPage: nextPerPage,
                    search: searchTerm,
                  });
                }}
                style={{
                  padding: "6px 8px",
                  borderRadius: "8px",
                  border: "1px solid #d9d9d9",
                }}
              >
                <option value={50}>50 / page</option>
                <option value={100}>100 / page</option>
                <option value={200}>200 / page</option>
              </select>
              <button
                type="button"
                onClick={() =>
                  fetchBorrowers({
                    page: borrowerPage - 1,
                    perPage: borrowersPerPage,
                    search: searchTerm,
                  })
                }
                disabled={borrowerPage <= 1 || isLoading}
                style={{
                  padding: "6px 10px",
                  borderRadius: "8px",
                  border: "1px solid #d9d9d9",
                  background: "white",
                }}
              >
                Prev
              </button>
              <button
                type="button"
                onClick={() =>
                  fetchBorrowers({
                    page: borrowerPage + 1,
                    perPage: borrowersPerPage,
                    search: searchTerm,
                  })
                }
                disabled={borrowerPage >= totalBorrowerPages || isLoading}
                style={{
                  padding: "6px 10px",
                  borderRadius: "8px",
                  border: "1px solid #d9d9d9",
                  background: "white",
                }}
              >
                Next
              </button>
            </div>
          </div>

          {!isAdmin ? (
            <div
              style={{
                display: "flex",
                justifyContent: "flex-end",
                marginBottom: "8px",
              }}
            >
              <div
                style={{
                  background: "white",
                  borderRadius: "999px",
                  padding: "6px 12px",
                  border: "1px solid #e6f0ff",
                  color: "#0e5aa5",
                  fontWeight: 700,
                  fontSize: "12px",
                }}
              >
                Clients loaded: {borrowers.length} / {totalBorrowers}
              </div>
            </div>
          ) : null}

          <div
            className="support-borrower-table"
            style={{
              background: "white",
              borderRadius: "16px",
              boxShadow: "0 12px 30px rgba(0,0,0,0.05)",
              overflow: "hidden",
            }}
          >
            <div
              className="support-borrower-header"
              style={{
                display: "grid",
                gridTemplateColumns:
                  "1.2fr 0.7fr 1fr 1fr 1fr 0.8fr 1fr 1fr 1fr 0.8fr 0.8fr 1.2fr 1.5fr",
                gap: "12px",
                padding: "14px 18px",
                background: "#f0f5ff",
                color: "#0e5aa5",
                fontWeight: 800,
                fontSize: "12px",
              }}
            >
              <div>Borrower Name</div>
              <div>Data</div>
              <div>Phone Number</div>
              <div>Email</div>
              <div>Registered</div>
              <div>BTI Rating</div>
              <div>Employee ID</div>
              <div>Employee Name</div>
              <div>Assigned By</div>
              <div>CBS Report</div>
              <div>Status</div>
              <div>Latest Remark</div>
              <div>Loan & Cases</div>
            </div>

            {isLoading ? (
              <div style={{ padding: "24px", textAlign: "center" }}>
                Loading...
              </div>
            ) : filteredBorrowers.length === 0 ? (
              <div
                style={{
                  padding: "24px",
                  textAlign: "center",
                  color: "#6b7b93",
                }}
              >
                No borrowers match your filters.
              </div>
            ) : (
              filteredBorrowers.map((borrower) => {
                const phoneNumber = normalizePhoneNumber(borrower.mobile_no);
                const cbsIntentAnswers = Array.isArray(
                  borrower.cbs_positive_intent_answers,
                )
                  ? borrower.cbs_positive_intent_answers.filter(Boolean)
                  : [];
                const cbsIntentTitle = cbsIntentAnswers.length
                  ? `CBS questionnaire: ${cbsIntentAnswers.join(", ")}`
                  : "CBS questionnaire showed financing interest";

                return (
                  <div
                    key={borrower.user_id}
                    className={`support-borrower-row support-borrower-row-layout ${
                      shouldHighlightAssignment(borrower)
                        ? "support-assignee-highlight"
                        : ""
                    } ${borrower.sl_created ? "support-sl-created-highlight" : ""} ${
                      borrower.cbs_positive_intent
                        ? "support-cbs-positive-intent-highlight"
                        : ""
                    }`}
                    style={{
                      display: "grid",
                      gridTemplateColumns:
                        "1.2fr 0.7fr 1fr 1fr 1fr 0.8fr 1fr 1fr 1fr 0.8fr 0.8fr 1.2fr 1.5fr",
                      gridTemplateRows: "auto auto",
                      gap: "12px",
                      padding: "14px 18px",
                      alignItems: "center",
                      borderTop: "1px solid #f0f0f0",
                    }}
                  >
                    <div className="support-borrower-cell support-borrower-primary">
                      <span className="support-borrower-label">
                        Borrower Name
                      </span>
                      <div className="support-borrower-primary-content">
                        <button
                          type="button"
                          onClick={() => toggleFavouriteBorrower(borrower)}
                          aria-label={
                            borrower.support_is_favourite
                              ? "Remove favourite"
                              : "Mark as favourite"
                          }
                          title={
                            borrower.support_is_favourite
                              ? "Remove favourite"
                              : "Keep client at top"
                          }
                          style={{
                            border: "none",
                            background: "transparent",
                            color: borrower.support_is_favourite
                              ? "#f5a623"
                              : "#b8c2d0",
                            cursor: "pointer",
                            padding: "2px 6px 2px 0",
                            fontSize: "16px",
                            lineHeight: 1,
                          }}
                        >
                          <FontAwesomeIcon icon={faStar} />
                        </button>
                        <div
                          className="support-borrower-primary-name"
                          style={{ fontWeight: 700 }}
                        >
                          {getBorrowerDisplayName(borrower)}
                        </div>
                        {borrower.cbs_positive_intent ? (
                          <span
                            className="support-cbs-intent-badge"
                            title={cbsIntentTitle}
                          >
                            CBS financing interest
                          </span>
                        ) : null}
                      </div>
                    </div>
                    <div className="support-borrower-cell">
                      <span className="support-borrower-label">Data</span>
                      <span
                        className="support-borrower-value"
                        style={{
                          display: "flex",
                          gap: "8px",
                          alignItems: "center",
                        }}
                      >
                        {hasSingpassPayload(borrower) ? (
                          <span title="Singpass data available">
                            <FontAwesomeIcon icon={faBuilding} />
                          </span>
                        ) : null}
                        {hasMyInfoPayload(borrower) ? (
                          <span title="MyInfo data available">
                            <FontAwesomeIcon icon={faUser} />
                          </span>
                        ) : null}
                        {!hasSingpassPayload(borrower) &&
                        !hasMyInfoPayload(borrower) ? (
                          <span>-</span>
                        ) : null}
                      </span>
                    </div>
                    <div className="support-borrower-cell">
                      <span className="support-borrower-label">
                        Phone Number
                      </span>
                      <span className="support-borrower-value support-phone-row">
                        <span>{borrower.mobile_no || "-"}</span>
                        {phoneNumber ? (
                          <span className="support-phone-actions">
                            <a
                              className="support-phone-action"
                              href={`tel:+${phoneNumber}`}
                              title="Call borrower"
                              aria-label={`Call ${
                                borrower.company_name || "borrower"
                              }`}
                            >
                              <FontAwesomeIcon icon={faPhone} />
                            </a>
                            <a
                              className="support-phone-action support-phone-action--whatsapp"
                              href={`https://wa.me/${phoneNumber}?text=${encodeURIComponent(
                                `Hi ${borrower.company_name || "there"}, `,
                              )}`}
                              target="_blank"
                              rel="noreferrer"
                              title="WhatsApp borrower"
                              aria-label={`WhatsApp ${
                                borrower.company_name || "borrower"
                              }`}
                            >
                              <FontAwesomeIcon icon={faWhatsapp} />
                            </a>
                          </span>
                        ) : null}
                      </span>
                    </div>
                    <div className="support-borrower-cell">
                      <span className="support-borrower-label">Email</span>
                      <span
                        className="support-borrower-value"
                        style={{ overflowWrap: "anywhere" }}
                      >
                        {borrower.email || "-"}
                      </span>
                    </div>
                    <div className="support-borrower-cell">
                      <span className="support-borrower-label">Registered</span>
                      <span className="support-borrower-value">
                        {formatDate(borrower.registered_at)}
                      </span>
                    </div>
                    <div className="support-borrower-cell">
                      <span className="support-borrower-label">BTI Rating</span>
                      <span className="support-borrower-value">
                        {borrower.bti_rating ?? "-"}
                      </span>
                    </div>
                    <div className="support-borrower-cell">
                      <span className="support-borrower-label">
                        Employee ID
                      </span>
                      <span className="support-borrower-value">
                        {borrower.assigned_support_id
                          ? `#${borrower.assigned_support_id}`
                          : "Unassigned"}
                      </span>
                    </div>
                    <div className="support-borrower-cell">
                      <span className="support-borrower-label">
                        Employee Name
                      </span>
                      <span className="support-borrower-value">
                        {getAssignedEmployeeName(borrower)}
                      </span>
                    </div>
                    <div className="support-borrower-cell">
                      <span className="support-borrower-label">
                        Assigned By
                      </span>
                      <span className="support-borrower-value">
                        {getAssignedByName(borrower)}
                      </span>
                    </div>
                    <div className="support-borrower-cell">
                      <span className="support-borrower-label">CBS Report</span>
                      <span className="support-borrower-value">
                        {borrower.has_cbs_report ? (
                          <button
                            type="button"
                            onClick={() => openCbsReport(borrower.user_id)}
                            style={{
                              padding: "6px 10px",
                              borderRadius: "8px",
                              border: "1px solid #0e5aa5",
                              background: "white",
                              color: "#0e5aa5",
                              cursor: "pointer",
                              fontWeight: 700,
                            }}
                          >
                            Open report
                          </button>
                        ) : (
                          "-"
                        )}
                      </span>
                    </div>
                    <div className="support-borrower-cell">
                      <span className="support-borrower-label">Status</span>
                      <div className="support-borrower-value">
                        <select
                          value={borrower.support_status || ""}
                          onChange={(e) =>
                            updateSupportStatus(
                              borrower.user_id,
                              e.target.value,
                              e.target.value === "Following Up"
                                ? borrower.support_follow_up_date || ""
                                : null,
                            )
                          }
                          style={{
                            width: "100%",
                            padding: "6px 8px",
                            borderRadius: "8px",
                            border: "1px solid #d9d9d9",
                            fontFamily: "inherit",
                            background: "white",
                          }}
                        >
                          <option value="" disabled>
                            Set status
                          </option>
                          {supportStatuses.map((status) => (
                            <option key={status} value={status}>
                              {status}
                            </option>
                          ))}
                        </select>
                        {borrower.support_status === "Following Up" ? (
                          <input
                            type="date"
                            value={borrower.support_follow_up_date || ""}
                            onChange={(e) =>
                              updateSupportStatus(
                                borrower.user_id,
                                "Following Up",
                                e.target.value,
                              )
                            }
                            title="Follow-up date"
                            style={{
                              width: "100%",
                              marginTop: "6px",
                              padding: "6px 8px",
                              borderRadius: "8px",
                              border: "1px solid #d9d9d9",
                              fontFamily: "inherit",
                              background: "white",
                            }}
                          />
                        ) : null}
                      </div>
                    </div>
                    <div className="support-borrower-cell">
                      <span className="support-borrower-label">
                        Latest Remark
                      </span>
                      <div
                        className="support-borrower-value"
                        onDoubleClick={() => openRemarkModal(borrower)}
                        style={{
                          cursor: "pointer",
                          color: borrower.latest_remark?.remark
                            ? "#1f1f1f"
                            : "#6b7b93",
                        }}
                        title="Double click to view or add remarks"
                      >
                        <div>
                          {borrower.latest_remark?.remark ||
                            "Double click to add remark"}
                        </div>
                        {borrower.latest_remark ? (
                          <div
                            style={{
                              marginTop: "4px",
                              fontSize: "11px",
                              color: "#8c8c8c",
                            }}
                          >
                            {borrower.latest_remark.author_name
                              ? borrower.latest_remark.author_name
                              : "Unknown author"}
                            {borrower.latest_remark.created_at_formatted
                              ? ` • ${borrower.latest_remark.created_at_formatted}`
                              : borrower.latest_remark.created_at
                                ? ` • ${formatDate(
                                    borrower.latest_remark.created_at,
                                  )}`
                                : ""}
                          </div>
                        ) : null}
                      </div>
                    </div>
                    <div className="support-borrower-cell">
                      <span className="support-borrower-label">
                        Loan & Cases
                      </span>
                      <div className="support-borrower-value">
                        {renderBorrowerLoanAndCaseSummary(borrower)}
                      </div>
                    </div>
                    <div
                      className="support-borrower-actions"
                      style={{
                        gridColumn: "1 / -1",
                        display: "flex",
                        flexWrap: "wrap",
                        gap: "8px",
                      }}
                    >
                      <button
                        style={{
                          padding: "6px 10px",
                          borderRadius: "8px",
                          border: "1px solid #0e5aa5",
                          background: "#0e5aa5",
                          color: "white",
                          cursor: "pointer",
                          fontWeight: 700,
                        }}
                        onClick={() => {
                          setSelectedBorrower(borrower);
                          fetchBorrowerProfile(borrower);
                        }}
                      >
                        View Details
                      </button>
                      <button
                        style={{
                          padding: "6px 10px",
                          borderRadius: "8px",
                          border: "1px solid #1769aa",
                          background: "#1769aa",
                          color: "white",
                          cursor: "pointer",
                          fontWeight: 700,
                        }}
                        onClick={() => openCreateCaseModal(borrower)}
                      >
                        Create Case
                      </button>
                      <button
                        style={{
                          padding: "6px 10px",
                          borderRadius: "8px",
                          border: "1px solid #0f766e",
                          background: "#0f766e",
                          color: "white",
                          cursor: "pointer",
                          fontWeight: 700,
                        }}
                        onClick={() => openCreateLoanModal(borrower)}
                      >
                        Create Loan
                      </button>
                      {borrower.assigned_support_id !==
                      parseFloat(employeeId) ? (
                        <button
                          style={{
                            padding: "6px 10px",
                            borderRadius: "8px",
                            border: "1px solid #0e5aa5",
                            background: "#0e5aa5",
                            color: "white",
                            cursor: "pointer",
                            fontWeight: 700,
                          }}
                          onClick={() => assignToMe(borrower.user_id)}
                        >
                          Assign to me
                        </button>
                      ) : null}
                      <button
                        style={{
                          padding: "6px 10px",
                          borderRadius: "8px",
                          border: "1px solid #0e5aa5",
                          background: "white",
                          color: "#0e5aa5",
                          cursor: "pointer",
                          fontWeight: 700,
                        }}
                        onClick={() => openAssigneeModal(borrower)}
                      >
                        Push Assignee
                      </button>
                      <button
                        style={{
                          padding: "6px 10px",
                          borderRadius: "8px",
                          border: "1px solid #1d6f42",
                          background: "#1d6f42",
                          color: "white",
                          cursor: "pointer",
                          fontWeight: 700,
                        }}
                        disabled={syncingBorrowerId === borrower.user_id}
                        onClick={() => startSupportSync(borrower, "singpass")}
                      >
                        Sync Singpass
                      </button>
                      <button
                        style={{
                          padding: "6px 10px",
                          borderRadius: "8px",
                          border: "1px solid #6f42c1",
                          background: "#6f42c1",
                          color: "white",
                          cursor: "pointer",
                          fontWeight: 700,
                        }}
                        disabled={syncingBorrowerId === borrower.user_id}
                        onClick={() => startSupportSync(borrower, "corppass")}
                      >
                        Sync Corppass
                      </button>
                      {[
                        {
                          source: "myinfo",
                          label: "Myinfo",
                          available: hasMyInfoPayload(borrower),
                        },
                        {
                          source: "corppass",
                          label: "CorpPass",
                          available: hasSingpassPayload(borrower),
                        },
                      ]
                        .filter((item) => item.available)
                        .map(({ source, label }) => {
                          const state =
                            crmImports[`${borrower.user_id}:${source}`];
                          return (
                            <div key={source} style={{ maxWidth: "300px" }}>
                              <button
                                type="button"
                                disabled={state?.loading}
                                onClick={() =>
                                  portBorrowerToCrm(borrower, source)
                                }
                                style={{
                                  padding: "6px 10px",
                                  borderRadius: "8px",
                                  border: "1px solid #0e5aa5",
                                  background: "white",
                                  color: "#0e5aa5",
                                  cursor: state?.loading ? "wait" : "pointer",
                                  opacity: state?.loading ? 0.6 : 1,
                                  fontWeight: 700,
                                }}
                              >
                                {state?.loading
                                  ? `Porting ${label}…`
                                  : `Port ${label} to CRM`}
                              </button>
                              {(state?.error || state?.message) && (
                                <div
                                  role="status"
                                  style={{
                                    fontSize: "12px",
                                    marginTop: "4px",
                                    color: state.error ? "#b42318" : "#16794b",
                                  }}
                                >
                                  {state.error || state.message}
                                </div>
                              )}
                              {state?.error && state?.diagnostics && (
                                <CrmImportDiagnostics
                                  diagnostics={state.diagnostics}
                                  borrowerId={borrower.user_id}
                                  source={label}
                                />
                              )}
                            </div>
                          );
                        })}
                    </div>
                  </div>
                );
              })
            )}
          </div>
        </>
      )}

      {selectedBorrower ? (
        <div
          style={{
            position: "fixed",
            inset: 0,
            background: "rgba(0,0,0,0.45)",
            display: "flex",
            alignItems: "center",
            justifyContent: "center",
            zIndex: 1000,
          }}
          onClick={closeModal}
        >
          <div
            onClick={(e) => e.stopPropagation()}
            style={{
              width: "95%",
              maxWidth: "1100px",
              background: "white",
              borderRadius: "16px",
              padding: "24px",
              boxShadow: "0 16px 40px rgba(0,0,0,0.12)",
              maxHeight: "90vh",
              overflow: "auto",
            }}
          >
            <div
              style={{
                display: "flex",
                justifyContent: "space-between",
                alignItems: "center",
              }}
            >
              <div>
                <div style={{ color: "#6b7b93", fontWeight: 700 }}>
                  Borrower
                </div>
                <div
                  style={{
                    fontWeight: 800,
                    fontSize: "20px",
                    color: "#0e5aa5",
                  }}
                >
                  {getBorrowerDisplayName(selectedBorrower)}
                </div>
              </div>
              <button
                onClick={closeModal}
                style={{
                  border: "none",
                  background: "transparent",
                  fontSize: "18px",
                  cursor: "pointer",
                }}
              >
                ✕
              </button>
            </div>

            <div style={{ marginTop: "16px", display: "grid", gap: "16px" }}>
              <div
                style={{
                  display: "grid",
                  gridTemplateColumns: "1.2fr 1fr",
                  gap: "16px",
                  alignItems: "start",
                }}
              >
                <div style={{ display: "grid", gap: "12px" }}>
                  <div>
                    <strong>Email:</strong> {selectedBorrower.email || "-"}
                  </div>
                  <div>
                    <strong>Phone:</strong> {selectedBorrower.mobile_no || "-"}
                  </div>
                  <div>
                    <strong>Registered:</strong>{" "}
                    {formatDate(selectedBorrower.registered_at)}
                  </div>
                  <div>
                    <strong>BTI Rating:</strong>{" "}
                    {selectedBorrower.bti_rating ?? "-"}
                  </div>
                  <div>
                    <strong>Support Status:</strong>{" "}
                    {selectedBorrower.support_status || "-"}
                  </div>
                  <div>
                    <strong>Assigned Support:</strong>{" "}
                    {selectedBorrower.assigned_support_id || "Unassigned"}
                  </div>
                  <div>
                    <strong>CBS Report:</strong>{" "}
                    {selectedBorrower.has_cbs_report
                      ? "Available"
                      : "Not uploaded"}
                  </div>
                  {selectedBorrower.product_interests?.length ? (
                    <div>
                      <strong>Product interest:</strong>
                      <div
                        style={{
                          marginTop: "8px",
                          display: "flex",
                          flexWrap: "wrap",
                          gap: "12px",
                        }}
                      >
                        {selectedBorrower.product_interests.map(
                          (interest, index) => {
                            const productMeta =
                              productIconMap[interest.product_page];
                            const deviceMeta =
                              deviceIconMap[interest.device_type];
                            if (!productMeta || !deviceMeta) {
                              return null;
                            }
                            const amountText =
                              interest.loan_amount !== null &&
                              interest.loan_amount !== undefined
                                ? ` • Amount: ${formatCurrency(interest.loan_amount)}`
                                : "";
                            const tooltip = `${productMeta.label} • ${deviceMeta.label}${amountText}`;
                            return (
                              <div
                                key={`${interest.product_page}-${interest.device_type}-${index}`}
                                title={tooltip}
                                style={{
                                  display: "flex",
                                  alignItems: "center",
                                  gap: "6px",
                                  padding: "6px 10px",
                                  borderRadius: "999px",
                                  background: "rgba(14,90,165,0.08)",
                                  color: "#0e5aa5",
                                  fontSize: "14px",
                                }}
                              >
                                <FontAwesomeIcon icon={deviceMeta.icon} />
                                <FontAwesomeIcon icon={productMeta.icon} />
                              </div>
                            );
                          },
                        )}
                      </div>
                    </div>
                  ) : null}
                  <div>
                    <strong>Welcome wizard:</strong>
                    <div style={{ marginTop: "6px", color: "#6b7b93" }}>
                      <div>
                        Signup reason:{" "}
                        {selectedBorrower.welcome_wizard_response
                          ?.signup_reason || "—"}
                      </div>
                      <div>
                        Personal goals:{" "}
                        {formatWizardList(
                          selectedBorrower.welcome_wizard_response
                            ?.personal_goals,
                        )}
                      </div>
                      <div>
                        Business goals:{" "}
                        {formatWizardList(
                          selectedBorrower.welcome_wizard_response
                            ?.business_goals,
                        )}
                      </div>
                      {selectedBorrower.welcome_wizard_response
                        ?.personal_other_text ? (
                        <div>
                          Personal other:{" "}
                          {
                            selectedBorrower.welcome_wizard_response
                              .personal_other_text
                          }
                        </div>
                      ) : null}
                      {selectedBorrower.welcome_wizard_response
                        ?.business_other_text ? (
                        <div>
                          Business other:{" "}
                          {
                            selectedBorrower.welcome_wizard_response
                              .business_other_text
                          }
                        </div>
                      ) : null}
                      <div>
                        CBS reason:{" "}
                        {selectedBorrower.welcome_wizard_response?.cbs_reason ||
                          "—"}
                      </div>
                    </div>
                  </div>
                  <div>
                    <button
                      onClick={() => assignToMe(selectedBorrower.user_id)}
                      style={{
                        padding: "10px 16px",
                        background: "#0e5aa5",
                        color: "white",
                        border: "none",
                        borderRadius: "10px",
                        fontWeight: 700,
                        cursor: "pointer",
                      }}
                    >
                      Mark as assigned
                    </button>
                  </div>
                  <div style={{ display: "grid", gap: "10px" }}>
                    <button
                      onClick={() => setShowCbsUploader((prev) => !prev)}
                      style={{
                        padding: "10px 16px",
                        background: "white",
                        color: "#0e5aa5",
                        border: "1px solid #0e5aa5",
                        borderRadius: "10px",
                        fontWeight: 700,
                        cursor: "pointer",
                      }}
                    >
                      {showCbsUploader
                        ? "Hide CBS upload"
                        : "Inject CBS report"}
                    </button>
                    {showCbsUploader ? (
                      <div
                        style={{
                          display: "grid",
                          gap: "8px",
                          background: "#f5f7fb",
                          borderRadius: "12px",
                          padding: "12px",
                        }}
                      >
                        <div style={{ fontWeight: 700, color: "#0e5aa5" }}>
                          Upload CBS report
                        </div>
                        <input
                          type="file"
                          onChange={(e) => {
                            const file = e.target.files?.[0];
                            if (!file) return;
                            extractText(file);
                            setCreditReportFile(file);
                          }}
                          style={{
                            outline: "none",
                            border: "1px solid #d9d9d9",
                            borderRadius: "8px",
                            fontSize: "12px",
                            padding: "6px 10px",
                            background: "white",
                          }}
                        />
                        <button
                          onClick={uploadCBSReport}
                          disabled={isUploadingCbs}
                          style={{
                            padding: "8px 12px",
                            background: "#0e5aa5",
                            color: "white",
                            border: "none",
                            borderRadius: "8px",
                            fontWeight: 700,
                            cursor: isUploadingCbs ? "not-allowed" : "pointer",
                            opacity: isUploadingCbs ? 0.7 : 1,
                          }}
                        >
                          {isUploadingCbs ? "Injecting..." : "Inject CBS"}
                        </button>
                      </div>
                    ) : null}
                  </div>
                </div>

                <div
                  style={{
                    background: "#f5f7fb",
                    borderRadius: "12px",
                    padding: "12px",
                    display: "flex",
                    flexDirection: "column",
                    gap: "10px",
                  }}
                >
                  <div style={{ fontWeight: 800, color: "#0e5aa5" }}>
                    Remarks
                  </div>
                  <textarea
                    value={newRemark}
                    onChange={(e) => setNewRemark(e.target.value)}
                    placeholder="Add a remark for this borrower"
                    style={{
                      minHeight: "80px",
                      borderRadius: "10px",
                      border: "1px solid #d9d9d9",
                      padding: "10px",
                      resize: "vertical",
                      fontFamily: "inherit",
                    }}
                  />
                  <button
                    onClick={() => addRemark(selectedBorrower.user_id)}
                    disabled={isSavingRemark}
                    style={{
                      alignSelf: "flex-end",
                      padding: "8px 12px",
                      borderRadius: "8px",
                      border: "none",
                      background: "#0e5aa5",
                      color: "white",
                      fontWeight: 700,
                      cursor: isSavingRemark ? "not-allowed" : "pointer",
                      opacity: isSavingRemark ? 0.7 : 1,
                    }}
                  >
                    {isSavingRemark ? "Saving..." : "Add Remark"}
                  </button>
                  <div style={{ display: "grid", gap: "8px" }}>
                    {remarks.map((remark) => (
                      <div
                        key={remark.id}
                        style={{
                          background: "white",
                          borderRadius: "10px",
                          padding: "10px",
                          border: "1px solid #e6ebf5",
                        }}
                      >
                        <div style={{ fontWeight: 700, color: "#0e5aa5" }}>
                          {remark.author_name || "Unknown"}
                        </div>
                        <div style={{ color: "#6b7b93", fontSize: "12px" }}>
                          {remark.created_at_formatted || ""}
                        </div>
                        <div style={{ marginTop: "6px" }}>{remark.remark}</div>
                      </div>
                    ))}
                    {remarks.length === 0 ? (
                      <div style={{ color: "#6b7b93", fontSize: "12px" }}>
                        No remarks yet.
                      </div>
                    ) : null}
                  </div>
                </div>
              </div>

              <div style={{ marginTop: "6px" }}>
                {isProfileLoading ? (
                  <div>Loading profile...</div>
                ) : selectedBorrowerProfile ? (
                  singpassData || myinfoData ? (
                    <ProfileViewer
                      keyman={keyman}
                      isMobile={false}
                      viewingUser={viewingUser}
                      setViewingUser={(data) => setViewingUser(data)}
                      singpassData={singpassData}
                      myinfoData={myinfoData}
                      personalOnly={
                        Boolean(myinfoData) && !Boolean(singpassData)
                      }
                      liveUserData={liveUserData}
                      otherAuthoriserDetails={otherAuthoriserDetails}
                      setLiveUserData={(data) => setLiveUserData(data)}
                      setViewingTab={(data) => setViewingTab(data)}
                      viewingTab={viewingTab}
                      badgeVerified={badgeVerified}
                      availableTab={availableTab}
                      allCBSData={allCBSData}
                      combinedSingpassData={combinedSingpassData}
                      getShareholderAddress={() => []}
                      backupContact={backupContact}
                    />
                  ) : (
                    <div style={{ color: "#6b7b93" }}>
                      No Singpass/MyInfo data available for profile viewer.
                    </div>
                  )
                ) : (
                  <div style={{ color: "#6b7b93" }}>
                    Select a borrower to load their profile.
                  </div>
                )}
              </div>
            </div>
          </div>
        </div>
      ) : null}

      {createLoanBorrower ? (
        <div
          style={{
            position: "fixed",
            inset: 0,
            background: "rgba(15, 23, 42, 0.45)",
            zIndex: 1000,
            display: "flex",
            alignItems: "center",
            justifyContent: "center",
            padding: "20px",
          }}
          onClick={() => closeCreateLoanModal()}
        >
          <div
            onClick={(e) => e.stopPropagation()}
            style={{
              width: "95%",
              maxWidth: "860px",
              background: "white",
              borderRadius: "16px",
              padding: "24px",
              boxShadow: "0 16px 40px rgba(0,0,0,0.12)",
              maxHeight: "90vh",
              overflow: "auto",
            }}
          >
            <div
              style={{
                display: "flex",
                justifyContent: "space-between",
                alignItems: "center",
                gap: "12px",
              }}
            >
              <div>
                <div style={{ color: "#6b7b93", fontWeight: 700 }}>
                  Create Loan
                </div>
                <div
                  style={{
                    fontWeight: 800,
                    fontSize: "20px",
                    color: "#0f766e",
                  }}
                >
                  {createLoanBorrower.company_name ||
                    getBorrowerDisplayName(createLoanBorrower)}
                </div>
              </div>
              <button
                onClick={() => closeCreateLoanModal()}
                style={{
                  border: "none",
                  background: "transparent",
                  fontSize: "18px",
                  cursor: "pointer",
                }}
              >
                ✕
              </button>
            </div>

            <div
              style={{
                marginTop: "18px",
                display: "grid",
                gridTemplateColumns: "repeat(auto-fit, minmax(210px, 1fr))",
                gap: "14px",
              }}
            >
              <label style={{ display: "grid", gap: 6, fontWeight: 700 }}>
                Loan type
                <select
                  value={createLoanForm.loan_type}
                  onChange={(e) =>
                    updateCreateLoanField("loan_type", e.target.value)
                  }
                  style={{
                    padding: "10px 12px",
                    borderRadius: "10px",
                    border: "1px solid #d9d9d9",
                  }}
                >
                  <option value="money_lender">Money lender loan</option>
                  <option value="corporate">Corporate loan</option>
                </select>
              </label>
              <label style={{ display: "grid", gap: 6, fontWeight: 700 }}>
                Case handling
                <select
                  value={createLoanForm.case_type}
                  onChange={(e) =>
                    updateCreateLoanField("case_type", e.target.value)
                  }
                  style={{
                    padding: "10px 12px",
                    borderRadius: "10px",
                    border: "1px solid #d9d9d9",
                  }}
                >
                  <option value="normal">Normal marketplace case</option>
                  <option value="concierge">Concierge no-contact case</option>
                </select>
              </label>
              <label style={{ display: "grid", gap: 6, fontWeight: 700 }}>
                Amount
                <input
                  type="number"
                  min="1"
                  value={createLoanForm.amount}
                  onChange={(e) =>
                    updateCreateLoanField("amount", e.target.value)
                  }
                  placeholder="50000"
                  style={{
                    padding: "10px 12px",
                    borderRadius: "10px",
                    border: "1px solid #d9d9d9",
                  }}
                />
              </label>
              <label style={{ display: "grid", gap: 6, fontWeight: 700 }}>
                Tenor (months)
                <input
                  type="number"
                  min="1"
                  value={createLoanForm.tenor_months}
                  onChange={(e) =>
                    updateCreateLoanField("tenor_months", e.target.value)
                  }
                  placeholder="12"
                  style={{
                    padding: "10px 12px",
                    borderRadius: "10px",
                    border: "1px solid #d9d9d9",
                  }}
                />
              </label>
              {createLoanForm.loan_type === "corporate" ? (
                <label style={{ display: "grid", gap: 6, fontWeight: 700 }}>
                  Interest rate (% p.m.)
                  <input
                    type="number"
                    min="0"
                    step="0.01"
                    value={createLoanForm.corporate_interest_rate}
                    onChange={(e) =>
                      updateCreateLoanField(
                        "corporate_interest_rate",
                        e.target.value,
                      )
                    }
                    style={{
                      padding: "10px 12px",
                      borderRadius: "10px",
                      border: "1px solid #d9d9d9",
                    }}
                  />
                </label>
              ) : (
                <label style={{ display: "grid", gap: 6, fontWeight: 700 }}>
                  Money lender rate (% p.m.)
                  <input
                    type="number"
                    min="0"
                    step="0.01"
                    value={createLoanForm.desired_rate_pa}
                    onChange={(e) =>
                      updateCreateLoanField("desired_rate_pa", e.target.value)
                    }
                    style={{
                      padding: "10px 12px",
                      borderRadius: "10px",
                      border: "1px solid #d9d9d9",
                    }}
                  />
                </label>
              )}
              <label style={{ display: "grid", gap: 6, fontWeight: 700 }}>
                Contact email
                <input
                  type="email"
                  value={createLoanForm.contact_email}
                  onChange={(e) =>
                    updateCreateLoanField("contact_email", e.target.value)
                  }
                  style={{
                    padding: "10px 12px",
                    borderRadius: "10px",
                    border: "1px solid #d9d9d9",
                  }}
                />
              </label>
              <label style={{ display: "grid", gap: 6, fontWeight: 700 }}>
                Contact phone
                <input
                  value={createLoanForm.contact_phone}
                  onChange={(e) =>
                    updateCreateLoanField("contact_phone", e.target.value)
                  }
                  style={{
                    padding: "10px 12px",
                    borderRadius: "10px",
                    border: "1px solid #d9d9d9",
                  }}
                />
              </label>
            </div>

            <div
              style={{
                marginTop: "18px",
                display: "grid",
                gridTemplateColumns: "repeat(auto-fit, minmax(240px, 1fr))",
                gap: "14px",
              }}
            >
              <label style={{ display: "grid", gap: 6, fontWeight: 700 }}>
                CBS report (optional)
                <input
                  type="file"
                  accept=".pdf,.zip"
                  onChange={(e) =>
                    updateCreateLoanField(
                      "cbs_report",
                      e.target.files?.[0] || null,
                    )
                  }
                />
              </label>
              {createLoanForm.loan_type === "money_lender" ? (
                <>
                  <label style={{ display: "grid", gap: 6, fontWeight: 700 }}>
                    Payslip documents (optional)
                    <input
                      type="file"
                      multiple
                      accept=".pdf,.jpg,.jpeg,.png"
                      onChange={(e) =>
                        updateCreateLoanFiles("payslips", e.target.files)
                      }
                    />
                  </label>
                  <label style={{ display: "grid", gap: 6, fontWeight: 700 }}>
                    MLCB report (optional)
                    <input
                      type="file"
                      accept=".pdf"
                      onChange={(e) =>
                        updateCreateLoanField(
                          "mlcb_report",
                          e.target.files?.[0] || null,
                        )
                      }
                    />
                  </label>
                </>
              ) : null}
              {createLoanForm.loan_type !== "money_lender" ? (
                <label style={{ display: "grid", gap: 6, fontWeight: 700 }}>
                  Bank statements (optional)
                  <input
                    type="file"
                    multiple
                    accept=".pdf,.csv,.xls,.xlsx,.zip"
                    onChange={(e) =>
                      updateCreateLoanFiles("bank_statements", e.target.files)
                    }
                  />
                </label>
              ) : null}
            </div>

            <label
              style={{
                display: "grid",
                gap: 6,
                fontWeight: 700,
                marginTop: "18px",
              }}
            >
              Support notes
              <textarea
                rows={3}
                value={createLoanForm.notes}
                onChange={(e) => updateCreateLoanField("notes", e.target.value)}
                style={{
                  padding: "10px 12px",
                  borderRadius: "10px",
                  border: "1px solid #d9d9d9",
                  resize: "vertical",
                }}
              />
            </label>

            <div
              style={{
                marginTop: "22px",
                display: "flex",
                justifyContent: "flex-end",
                gap: "10px",
              }}
            >
              <button
                type="button"
                onClick={() => closeCreateLoanModal()}
                disabled={isCreatingLoan}
                style={{
                  padding: "10px 14px",
                  borderRadius: "8px",
                  border: "1px solid #d9d9d9",
                  background: "white",
                  cursor: isCreatingLoan ? "not-allowed" : "pointer",
                  fontWeight: 700,
                }}
              >
                Cancel
              </button>
              <button
                type="button"
                onClick={submitSupportLoan}
                disabled={isCreatingLoan}
                style={{
                  padding: "10px 14px",
                  borderRadius: "8px",
                  border: "none",
                  background: "#0f766e",
                  color: "white",
                  cursor: isCreatingLoan ? "not-allowed" : "pointer",
                  fontWeight: 700,
                }}
              >
                {isCreatingLoan ? "Creating..." : "Submit loan"}
              </button>
            </div>
          </div>
        </div>
      ) : null}

      {caseBorrower ? (
        <div
          style={{
            position: "fixed",
            inset: 0,
            background: "rgba(0,0,0,0.45)",
            display: "flex",
            alignItems: "center",
            justifyContent: "center",
            zIndex: 1000,
          }}
          onClick={closeCreateCaseModal}
        >
          <div
            onClick={(e) => e.stopPropagation()}
            style={{
              width: "95%",
              maxWidth: "980px",
              background: "white",
              borderRadius: "16px",
              padding: "24px",
              boxShadow: "0 16px 40px rgba(0,0,0,0.12)",
              maxHeight: "90vh",
              overflow: "auto",
            }}
          >
            <div
              style={{
                display: "flex",
                justifyContent: "space-between",
                alignItems: "center",
              }}
            >
              <div>
                <div style={{ color: "#6b7b93", fontWeight: 700 }}>
                  Support Case
                </div>
                <div
                  style={{
                    fontWeight: 800,
                    fontSize: "20px",
                    color: "#0e5aa5",
                  }}
                >
                  {caseBorrower.company_name || "Borrower"}
                </div>
              </div>
              <button
                onClick={closeCreateCaseModal}
                style={{
                  border: "none",
                  background: "transparent",
                  fontSize: "18px",
                  cursor: "pointer",
                }}
              >
                ✕
              </button>
            </div>

            <div
              style={{
                marginTop: "16px",
                display: "grid",
                gridTemplateColumns: "1fr auto",
                gap: "10px",
                alignItems: "end",
              }}
            >
              <div>
                <label
                  style={{ fontWeight: 700, display: "block", marginBottom: 6 }}
                >
                  Product
                </label>
                <select
                  value={selectedCaseProduct}
                  onChange={(e) => setSelectedCaseProduct(e.target.value)}
                  style={{
                    width: "100%",
                    padding: "10px 12px",
                    borderRadius: "10px",
                    border: "1px solid #d9d9d9",
                  }}
                >
                  <option value="money_lender">Money lender</option>
                  <option value="personal_loan_bank">
                    Personal Loan (Bank)
                  </option>
                  <option value="corporate_loan">Corporate loan</option>
                  <option value="property_term_loan">Property term loan</option>
                </select>
              </div>
              <button
                type="button"
                onClick={createSupportCase}
                disabled={isCreatingCase}
                style={{
                  padding: "10px 14px",
                  borderRadius: "8px",
                  border: "none",
                  background: "#0e5aa5",
                  color: "white",
                  fontWeight: 700,
                  cursor: isCreatingCase ? "not-allowed" : "pointer",
                }}
              >
                {isCreatingCase ? "Creating..." : "Create case"}
              </button>
            </div>

            <div
              style={{
                marginTop: "16px",
                display: "grid",
                gridTemplateColumns: "300px 1fr",
                gap: "14px",
              }}
            >
              <div
                style={{
                  border: "1px solid #e6ebf5",
                  borderRadius: "12px",
                  padding: "10px",
                  maxHeight: "55vh",
                  overflow: "auto",
                }}
              >
                <div style={{ fontWeight: 700, marginBottom: "8px" }}>
                  Cases
                </div>
                {borrowerCases.map((item) => (
                  <div key={item.id} style={{ marginBottom: "8px" }}>
                    <button
                      type="button"
                      onClick={() => {
                        setSelectedCase(item);
                        loadCaseTimeline(item.id);
                      }}
                      style={{
                        width: "100%",
                        textAlign: "left",
                        border: item.is_loan_tagged
                          ? "1px solid #9254de"
                          : selectedCase?.id === item.id
                            ? "1px solid #0e5aa5"
                            : "1px solid #d9d9d9",
                        background: item.is_loan_tagged
                          ? "#f9f0ff"
                          : selectedCase?.id === item.id
                            ? "#f0f5ff"
                            : "white",
                        borderRadius: "8px",
                        padding: "10px",
                        cursor: "pointer",
                      }}
                    >
                      <div style={{ fontWeight: 700 }}>
                        {item.product_label || item.product}
                      </div>
                      <div style={{ fontSize: "12px", color: "#6b7b93" }}>
                        {item.created_at_formatted || ""}
                      </div>
                      {item.is_loan_tagged ? (
                        <div
                          style={{
                            fontSize: "12px",
                            color: "#722ed1",
                            fontWeight: 700,
                          }}
                        >
                          Tagged: {item.tagged_loan_type_label} #
                          {item.tagged_loan_request_id} (
                          {formatCurrency(item.tagged_loan_amount)})
                        </div>
                      ) : null}
                    </button>
                    <button
                      type="button"
                      onClick={() => deleteSupportCaseById(item.id)}
                      disabled={deletingCaseId === item.id}
                      style={{
                        marginTop: "6px",
                        width: "100%",
                        padding: "8px 10px",
                        borderRadius: "8px",
                        border: "1px solid #ff7875",
                        background: "#fff1f0",
                        color: "#cf1322",
                        fontWeight: 700,
                        cursor:
                          deletingCaseId === item.id
                            ? "not-allowed"
                            : "pointer",
                      }}
                    >
                      {deletingCaseId === item.id
                        ? "Deleting..."
                        : "Delete case"}
                    </button>
                  </div>
                ))}
                {borrowerCases.length === 0 ? (
                  <div style={{ color: "#6b7b93", fontSize: "12px" }}>
                    No cases yet.
                  </div>
                ) : null}
              </div>

              <div
                style={{
                  border: "1px solid #e6ebf5",
                  borderRadius: "12px",
                  padding: "12px",
                }}
              >
                {selectedCase ? (
                  <>
                    <div
                      style={{
                        display: "flex",
                        justifyContent: "space-between",
                        gap: "8px",
                        alignItems: "center",
                      }}
                    >
                      <div
                        style={{
                          fontWeight: 800,
                          color: selectedCase.is_loan_tagged
                            ? "#722ed1"
                            : "#0e5aa5",
                        }}
                      >
                        {selectedCase.product_label || selectedCase.product}
                        {selectedCase.is_loan_tagged
                          ? ` • Tagged ${selectedCase.tagged_loan_type_label} #${selectedCase.tagged_loan_request_id} (${formatCurrency(selectedCase.tagged_loan_amount)})`
                          : ""}
                      </div>
                      <div style={{ display: "flex", gap: "8px" }}>
                        <button
                          type="button"
                          onClick={() =>
                            openTagLoanModal(
                              selectedCase.id,
                              caseBorrower?.user_id,
                            )
                          }
                          style={{
                            padding: "8px 12px",
                            borderRadius: "8px",
                            border: "none",
                            background: "#722ed1",
                            color: "white",
                            fontWeight: 700,
                          }}
                        >
                          {taggingLoanCaseId === selectedCase.id
                            ? "Tagging..."
                            : "Tag Loans"}
                        </button>
                        <button
                          type="button"
                          onClick={() => deleteSupportCaseById(selectedCase.id)}
                          disabled={deletingCaseId === selectedCase.id}
                          style={{
                            padding: "8px 12px",
                            borderRadius: "8px",
                            border: "1px solid #ff7875",
                            background: "#fff1f0",
                            color: "#cf1322",
                            fontWeight: 700,
                          }}
                        >
                          {deletingCaseId === selectedCase.id
                            ? "Deleting..."
                            : "Delete case"}
                        </button>
                      </div>
                    </div>

                    <div
                      style={{
                        marginTop: "12px",
                        display: "grid",
                        gap: "8px",
                        maxHeight: "34vh",
                        overflow: "auto",
                        paddingRight: "4px",
                      }}
                    >
                      {caseTimeline.map((item) => (
                        <div
                          key={item.id}
                          style={{
                            border: "1px solid #e6ebf5",
                            borderRadius: "8px",
                            padding: "10px",
                            background: "#fafcff",
                          }}
                        >
                          <div
                            style={{
                              fontWeight: 700,
                              textTransform: "capitalize",
                            }}
                          >
                            {item.activity_type}
                          </div>
                          <div style={{ fontSize: "12px", color: "#6b7b93" }}>
                            {item.author_name || "System"} •{" "}
                            {item.created_at_formatted || ""}
                          </div>
                          {item.remark ? (
                            <div style={{ marginTop: "6px" }}>
                              {item.remark}
                            </div>
                          ) : null}
                          {item.document_url ? (
                            <a
                              href={item.document_url}
                              target="_blank"
                              rel="noreferrer"
                              style={{
                                marginTop: "6px",
                                display: "inline-block",
                                color: "#0e5aa5",
                              }}
                            >
                              {item.document_name || "View document"}
                            </a>
                          ) : null}
                        </div>
                      ))}
                      {caseTimeline.length === 0 ? (
                        <div style={{ color: "#6b7b93", fontSize: "12px" }}>
                          No timeline entries yet.
                        </div>
                      ) : null}
                    </div>

                    <div
                      style={{
                        marginTop: "12px",
                        display: "grid",
                        gap: "10px",
                      }}
                    >
                      <textarea
                        value={newCaseRemark}
                        onChange={(e) => setNewCaseRemark(e.target.value)}
                        placeholder="Add case remark"
                        style={{
                          minHeight: "70px",
                          borderRadius: "10px",
                          border: "1px solid #d9d9d9",
                          padding: "10px",
                        }}
                      />
                      <button
                        type="button"
                        onClick={addCaseRemark}
                        disabled={isSavingCaseRemark}
                        style={{
                          alignSelf: "flex-end",
                          padding: "8px 12px",
                          borderRadius: "8px",
                          border: "none",
                          background: "#0e5aa5",
                          color: "white",
                          fontWeight: 700,
                        }}
                      >
                        {isSavingCaseRemark ? "Saving..." : "Add remark"}
                      </button>

                      <input
                        type="file"
                        onChange={(e) =>
                          setCaseDocumentFile(e.target.files?.[0] || null)
                        }
                      />
                      <input
                        type="text"
                        value={caseDocumentRemark}
                        onChange={(e) => setCaseDocumentRemark(e.target.value)}
                        placeholder="Document remark (optional)"
                        style={{
                          borderRadius: "10px",
                          border: "1px solid #d9d9d9",
                          padding: "10px",
                        }}
                      />
                      <button
                        type="button"
                        onClick={uploadCaseDocument}
                        disabled={!caseDocumentFile || isUploadingCaseDocument}
                        style={{
                          alignSelf: "flex-end",
                          padding: "8px 12px",
                          borderRadius: "8px",
                          border: "none",
                          background: "#1d6f42",
                          color: "white",
                          fontWeight: 700,
                        }}
                      >
                        {isUploadingCaseDocument
                          ? "Uploading..."
                          : "Upload document"}
                      </button>
                    </div>
                  </>
                ) : (
                  <div style={{ color: "#6b7b93" }}>
                    Create or select a case to view timeline.
                  </div>
                )}
              </div>
            </div>
          </div>
        </div>
      ) : null}

      {tagLoanModal.open ? (
        <div
          style={{
            position: "fixed",
            inset: 0,
            background: "rgba(0,0,0,0.45)",
            display: "flex",
            alignItems: "center",
            justifyContent: "center",
            zIndex: 1001,
          }}
          onClick={closeTagLoanModal}
        >
          <div
            onClick={(e) => e.stopPropagation()}
            style={{
              width: "95%",
              maxWidth: "680px",
              background: "white",
              borderRadius: "16px",
              padding: "20px",
              boxShadow: "0 16px 40px rgba(0,0,0,0.12)",
              maxHeight: "80vh",
              overflow: "auto",
            }}
          >
            <div
              style={{
                display: "flex",
                justifyContent: "space-between",
                alignItems: "center",
                marginBottom: "12px",
              }}
            >
              <div
                style={{ fontWeight: 800, color: "#722ed1", fontSize: "18px" }}
              >
                Tag Loans
              </div>
              <button
                onClick={closeTagLoanModal}
                style={{
                  border: "none",
                  background: "transparent",
                  fontSize: "18px",
                  cursor: "pointer",
                }}
              >
                ✕
              </button>
            </div>

            {isLoadingAvailableLoans ? (
              <div style={{ color: "#6b7b93" }}>Loading loans...</div>
            ) : availableLoans.length === 0 ? (
              <div style={{ color: "#6b7b93" }}>
                No loans found for this borrower.
              </div>
            ) : (
              <div style={{ display: "grid", gap: "8px" }}>
                {availableLoans.map((loan) => (
                  <button
                    key={`${loan.loan_type}-${loan.id}`}
                    type="button"
                    onClick={() =>
                      tagLoanToCase(
                        tagLoanModal.caseId,
                        tagLoanModal.borrowerId,
                        loan,
                      )
                    }
                    disabled={taggingLoanCaseId === tagLoanModal.caseId}
                    style={{
                      textAlign: "left",
                      width: "100%",
                      border: "1px solid #d9d9d9",
                      borderRadius: "10px",
                      padding: "10px",
                      background: "white",
                      cursor: "pointer",
                    }}
                  >
                    <div style={{ fontWeight: 700, color: "#111" }}>
                      {loan.loan_type_label}
                    </div>
                    <div style={{ fontSize: "13px", color: "#6b7b93" }}>
                      Amount:{" "}
                      {loan.loan_amount !== null &&
                      loan.loan_amount !== undefined &&
                      loan.loan_amount !== ""
                        ? Number(loan.loan_amount).toLocaleString("en-SG", {
                            style: "currency",
                            currency: "SGD",
                            maximumFractionDigits: 2,
                          })
                        : "-"}
                    </div>
                  </button>
                ))}
              </div>
            )}
          </div>
        </div>
      ) : null}

      {remarkBorrower ? (
        <div
          style={{
            position: "fixed",
            inset: 0,
            background: "rgba(0,0,0,0.45)",
            display: "flex",
            alignItems: "center",
            justifyContent: "center",
            zIndex: 1000,
          }}
          onClick={closeRemarkModal}
        >
          <div
            onClick={(e) => e.stopPropagation()}
            style={{
              width: "95%",
              maxWidth: "640px",
              background: "white",
              borderRadius: "16px",
              padding: "24px",
              boxShadow: "0 16px 40px rgba(0,0,0,0.12)",
              maxHeight: "90vh",
              overflow: "auto",
            }}
          >
            <div
              style={{
                display: "flex",
                justifyContent: "space-between",
                alignItems: "center",
              }}
            >
              <div>
                <div style={{ color: "#6b7b93", fontWeight: 700 }}>Remarks</div>
                <div
                  style={{
                    fontWeight: 800,
                    fontSize: "20px",
                    color: "#0e5aa5",
                  }}
                >
                  {remarkBorrower.company_name || "Borrower"}
                </div>
              </div>
              <button
                onClick={closeRemarkModal}
                style={{
                  border: "none",
                  background: "transparent",
                  fontSize: "18px",
                  cursor: "pointer",
                }}
              >
                ✕
              </button>
            </div>

            <div style={{ marginTop: "16px", display: "grid", gap: "12px" }}>
              <textarea
                value={newRemark}
                onChange={(e) => setNewRemark(e.target.value)}
                placeholder="Add a remark for this borrower"
                style={{
                  minHeight: "90px",
                  borderRadius: "10px",
                  border: "1px solid #d9d9d9",
                  padding: "10px",
                  resize: "vertical",
                  fontFamily: "inherit",
                }}
              />
              <button
                onClick={() => addRemark(remarkBorrower.user_id)}
                disabled={isSavingRemark}
                style={{
                  alignSelf: "flex-end",
                  padding: "8px 12px",
                  borderRadius: "8px",
                  border: "none",
                  background: "#0e5aa5",
                  color: "white",
                  fontWeight: 700,
                  cursor: isSavingRemark ? "not-allowed" : "pointer",
                  opacity: isSavingRemark ? 0.7 : 1,
                }}
              >
                {isSavingRemark ? "Saving..." : "Add Remark"}
              </button>
              <div style={{ display: "grid", gap: "8px" }}>
                {remarks.map((remark) => (
                  <div
                    key={remark.id}
                    style={{
                      background: "#f5f7fb",
                      borderRadius: "10px",
                      padding: "10px",
                      border: "1px solid #e6ebf5",
                    }}
                  >
                    <div style={{ fontWeight: 700, color: "#0e5aa5" }}>
                      {remark.author_name || "Unknown"}
                    </div>
                    <div style={{ color: "#6b7b93", fontSize: "12px" }}>
                      {remark.created_at_formatted || ""}
                    </div>
                    <div style={{ marginTop: "6px" }}>{remark.remark}</div>
                  </div>
                ))}
                {remarks.length === 0 ? (
                  <div style={{ color: "#6b7b93", fontSize: "12px" }}>
                    No remarks yet.
                  </div>
                ) : null}
              </div>
            </div>
          </div>
        </div>
      ) : null}

      {isAssigneeModalOpen && assigneeTarget ? (
        <div
          style={{
            position: "fixed",
            inset: 0,
            background: "rgba(0,0,0,0.45)",
            display: "flex",
            alignItems: "center",
            justifyContent: "center",
            zIndex: 1000,
          }}
          onClick={closeAssigneeModal}
        >
          <div
            onClick={(e) => e.stopPropagation()}
            style={{
              width: "95%",
              maxWidth: "520px",
              background: "white",
              borderRadius: "16px",
              padding: "24px",
              boxShadow: "0 16px 40px rgba(0,0,0,0.12)",
              maxHeight: "90vh",
              overflow: "auto",
            }}
          >
            <div
              style={{
                display: "flex",
                justifyContent: "space-between",
                alignItems: "center",
              }}
            >
              <div>
                <div style={{ color: "#6b7b93", fontWeight: 700 }}>
                  Push Assignee
                </div>
                <div
                  style={{
                    fontWeight: 800,
                    fontSize: "20px",
                    color: "#0e5aa5",
                  }}
                >
                  {assigneeTarget.company_name || "Borrower"}
                </div>
              </div>
              <button
                onClick={closeAssigneeModal}
                style={{
                  border: "none",
                  background: "transparent",
                  fontSize: "18px",
                  cursor: "pointer",
                }}
              >
                ✕
              </button>
            </div>

            {assigneeStep === 1 ? (
              <div style={{ marginTop: "16px", display: "grid", gap: "12px" }}>
                <label style={{ fontWeight: 700 }}>Select assignee</label>
                <select
                  value={selectedAssigneeId}
                  onChange={(e) => setSelectedAssigneeId(e.target.value)}
                  style={{
                    width: "100%",
                    padding: "10px 12px",
                    borderRadius: "10px",
                    border: "1px solid #d9d9d9",
                    fontFamily: "inherit",
                    background: "white",
                  }}
                >
                  <option value="" disabled>
                    Choose an employee
                  </option>
                  {assigneeOptions.map((assignee) => (
                    <option key={assignee.id} value={assignee.id}>
                      {assignee.name}
                    </option>
                  ))}
                </select>
                <div style={{ display: "flex", gap: "8px" }}>
                  <button
                    onClick={closeAssigneeModal}
                    style={{
                      padding: "8px 12px",
                      borderRadius: "8px",
                      border: "1px solid #d9d9d9",
                      background: "white",
                      cursor: "pointer",
                    }}
                  >
                    Cancel
                  </button>
                  <button
                    onClick={() => {
                      if (!selectedAssigneeId) {
                        message.warning("Please select an assignee.");
                        return;
                      }
                      setAssigneeStep(2);
                    }}
                    style={{
                      padding: "8px 12px",
                      borderRadius: "8px",
                      border: "none",
                      background: "#0e5aa5",
                      color: "white",
                      fontWeight: 700,
                      cursor: "pointer",
                    }}
                  >
                    Proceed
                  </button>
                </div>
              </div>
            ) : (
              <div style={{ marginTop: "16px", display: "grid", gap: "12px" }}>
                <label style={{ fontWeight: 700 }}>
                  Leave a remark (optional)
                </label>
                <textarea
                  value={assigneeRemark}
                  onChange={(e) => setAssigneeRemark(e.target.value)}
                  placeholder="Add a note for the next assignee"
                  style={{
                    minHeight: "100px",
                    borderRadius: "10px",
                    border: "1px solid #d9d9d9",
                    padding: "10px",
                    resize: "vertical",
                    fontFamily: "inherit",
                  }}
                />
                <div style={{ display: "flex", gap: "8px" }}>
                  <button
                    onClick={() => setAssigneeStep(1)}
                    style={{
                      padding: "8px 12px",
                      borderRadius: "8px",
                      border: "1px solid #d9d9d9",
                      background: "white",
                      cursor: "pointer",
                    }}
                  >
                    Back
                  </button>
                  <button
                    onClick={reassignBorrower}
                    disabled={isAssigningBorrower}
                    style={{
                      padding: "8px 12px",
                      borderRadius: "8px",
                      border: "none",
                      background: "#0e5aa5",
                      color: "white",
                      fontWeight: 700,
                      cursor: isAssigningBorrower ? "not-allowed" : "pointer",
                      opacity: isAssigningBorrower ? 0.7 : 1,
                    }}
                  >
                    {isAssigningBorrower ? "Assigning..." : "Assign"}
                  </button>
                </div>
              </div>
            )}
          </div>
        </div>
      ) : null}
    </div>
  );
};

export default SupportDashboard;
